export default {
    "en": {
        "imgExtender": {
            "title": "Free AI Image Extender - Outpaint Photos | WeryAI",
            "description": "Extend any image beyond its borders with AI outpainting. Generate seamless content that matches the original scene. Free credits on signup, no card needed.",
            "keywords": "AI image extender, outpaint image, extend image beyond borders, expand photo AI, image expansion tool, generative fill, WeryAI",
            "og_title": "Free AI Image Extender - Outpaint Photos | WeryAI",
            "og_description": "Extend any image beyond its borders with AI outpainting. Generate seamless content that matches the original scene. Free credits on signup, no card needed.",
            "twitter_title": "Free AI Image Extender - Outpaint Photos | WeryAI",
            "twitter_description": "Extend any image beyond its borders with AI outpainting. Generate seamless content that matches the original scene. Free credits on signup, no card needed.",
            "featureList": [
                "AI image extender, free image expansion, wide-angle photo generator, preserve original quality"
            ],
            "page": {
                "title1": "A powerful AI Image Extender for stunning results",
                "title2": "With just a few clicks, expand beyond your photo's original borders. Our AI Image Extender generates new pixels that seamlessly blend with your upload—turn portraits into wide-angle photos while keeping the original look and quality.",
                "feature_title": "What makes WeryAI Image Extender special | WeryAI",
                "faq": [
                    {
                        "question": "What is an AI Image Extender?",
                        "answer": "Powered by advanced AI, this tool expands an image by intelligently filling missing areas beyond the original boundaries. It creates a larger version of your photo, great for marketing, e-commerce, and social media. Need to resize for a specific platform? Try our <a href=\"/ai-image-resizer\">Image Resizer</a>."
                    },
                    {
                        "question": "Why use our AI Image Extender?",
                        "answer": "WeryAI uses state-of-the-art models to analyze image features and seamlessly outpaint surrounding areas with natural, high-definition results."
                    },
                    {
                        "question": "Can I use WeryAI Image Extender for free?",
                        "answer": "Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends, so you can keep using the Image Extender without an upfront payment."
                    },
                    {
                        "question": "How fast is the AI Image Extender?",
                        "answer": "Usually it completes in seconds with minimal waiting. It's ideal for handling both quick edits and batch workflows."
                    },
                    {
                        "question": "Will it affect resolution or quality?",
                        "answer": "No. The tool preserves resolution, clarity, and details during expansion—safe for personal and professional use."
                    },
                    {
                        "question": "Will my uploaded image stay private?",
                        "answer": "Yes. We protect your data with industry-standard security and strict privacy practices to ensure your images are not shared with third parties."
                    },
                    {
                        "question": "What image formats are supported?",
                        "answer": "JPG, PNG, WebP and other common formats are supported. Max file size is 10MB—no conversion needed."
                    }
                ]
            },
            "faq": [
                {
                    "question": "What is an AI Image Extender?",
                    "answer": "Powered by advanced AI, this tool expands an image by intelligently filling missing areas beyond the original boundaries. It creates a larger version of your photo, great for marketing, e-commerce, and social media."
                },
                {
                    "question": "Why use our AI Image Extender?",
                    "answer": "WeryAI uses state-of-the-art models to analyze image features and seamlessly outpaint surrounding areas with natural, high-definition results."
                },
                {
                    "question": "Can I use WeryAI Image Extender for free?",
                    "answer": "Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends, so you can keep using the Image Extender without an upfront payment."
                },
                {
                    "question": "How fast is the AI Image Extender?",
                    "answer": "Usually it completes in seconds with minimal waiting. It's ideal for handling both quick edits and batch workflows."
                },
                {
                    "question": "Will it affect resolution or quality?",
                    "answer": "No. The tool preserves resolution, clarity, and details during expansion—safe for personal and professional use."
                },
                {
                    "question": "Will my uploaded image stay private?",
                    "answer": "Yes. We protect your data with industry-standard security and strict privacy practices to ensure your images are not shared with third parties."
                },
                {
                    "question": "What image formats are supported?",
                    "answer": "JPG, PNG, WebP and other common formats are supported. Max file size is 10MB—no conversion needed."
                }
            ],
            "feature_title1": "Recover missing details and background",
            "feature_desc1": "If your photo was cropped, intelligently fill missing details to make the frame complete. The tool supports outpainting to restore missing elements in old photos and bring back meaningful memories.",
            "feature_title2": "Improve product photos to boost sales",
            "feature_desc2": "Expand the area around product images to add complementary background elements. You can also create wider compositions to showcase more product details and increase conversions.",
            "feature_title3": "Create unique visual masterpieces",
            "feature_desc3": "Whether you're a photographer, content creator, or artist, expand beyond the edges to push creative boundaries and turn your ideas into stunning visuals.",
            "feature_title4": "Optimize aspect ratios for social media",
            "feature_desc4": "Expand images to fit any ratio for Instagram, X (formerly Twitter), Facebook, and more. The AI keeps details sharp so the final result remains eye-catching.",
            "textRemoverHowToUseTitle": "How to use our AI Image Extender",
            "textRemoverHowToUseDesc": "3 simple steps to expand your photo beyond its borders",
            "textRemoverHowToUseStep1Title": "Upload an image",
            "textRemoverHowToUseStep1Desc": "Click or drag and drop the image you want to expand.",
            "textRemoverHowToUseStep2Title": "AI auto-processes",
            "textRemoverHowToUseStep2Desc": "After upload, the AI will automatically detect and extend the image borders.",
            "textRemoverHowToUseStep3Title": "Download the expanded image",
            "textRemoverHowToUseStep3Desc": "When it’s ready, preview and download your expanded image!",
            "howto": {
                "name": "How to Extend an Image with AI",
                "step1": {
                    "name": "Upload Photo",
                    "text": "Upload the photo you want to extend to WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Select Area",
                    "text": "Select the area or aspect ratio you want to extend the image to."
                },
                "step3": {
                    "name": "AI Outpaint",
                    "text": "Click 'Create'. The AI will intelligently generate new pixels and seamlessly extend your image."
                }
            }
        }
    },
    "zh": {
        "imgExtender": {
            "title": "免费 AI 图片扩展器 - AI 外扩图片 | WeryAI",
            "description": "使用 WeryAI 的免费 AI 图像扩展器，立即突破照片原始边界进行扩展。我们的 AI 图像扩展工具能生成与上传图像完美融合的新像素，让您将人像转化为广角照片，同时保留原始外观与画质。",
            "keywords": "AI图像扩展器, 免费图像扩展, 广角照片生成, 突破照片边界, 无缝融合, 保留原始画质",
            "og_title": "免费 AI 图片扩展器 - AI 外扩图片 | WeryAI",
            "og_description": "使用我们的 AI 图像扩展器将您的照片扩展至新尺寸并生成其他合适的内容。立即免费试用我们的 AI 图像扩展器。",
            "twitter_title": "免费 AI 图片扩展器 - AI 外扩图片 | WeryAI",
            "twitter_description": "使用我们的 AI 图像扩展器将您的照片扩展至新尺寸并生成其他合适的内容。立即免费试用我们的 AI 图像扩展器。",
            "featureList": [
                "AI图像扩展器, 免费图像扩展, 广角照片生成, 保留原始画质"
            ],
            "page": {
                "title1": "强大的AI图像扩展器，呈现惊艳效果",
                "title2": "只需简单点击，即可轻松突破照片原始边界进行扩展。我们的AI图像扩展工具能生成与上传图像完美融合的新像素，让您将人像转化为广角照片，同时保留原始外观与画质。",
                "feature_title": "WeryAI图像扩展器特色之处",
                "faq": [
                    {
                        "question": "什么是AI图像扩展器？",
                        "answer": "基于先进AI算法，此工具可通过智能填充缺失内容扩展图像边界，生成更大尺寸版本，适用于营销、电商、社交媒体发布等多种场景"
                    },
                    {
                        "question": "为什么要使用我们的 AI 图像扩展器？",
                        "answer": "WeryAI采用最顶尖的AI算法智能分析图像特征，无缝填充周边区域并保持自然高清效果。"
                    },
                    {
                        "question": "WeryAI AI 图片扩展器可以免费使用吗？",
                        "answer": "可以。新用户注册即可获得免费积分，无需信用卡。你还可以通过每日签到、完成任务和邀请好友获取更多免费积分，因此可以在无需预付费的情况下持续使用该工具。"
                    },
                    {
                        "question": "我们的 AI 图像扩展器处理照片的速度有多快？",
                        "answer": "通常数秒内完成扩展，无延迟或错误。这使得我们的 AI 扩展图像工具非常适合帮助您处理各种批量图像编辑任务。"
                    },
                    {
                        "question": "AI图像扩展器会影响分辨率或质量吗？",
                        "answer": "完全不会。工具在扩展过程中保持分辨率、清晰度与细节完整性，个人或专业用途皆可放心使用。"
                    },
                    {
                        "question": "我上传的图片会保持私密吗？",
                        "answer": "绝对安全！采用行业标准加密技术保障数据隐私，严格政策确保图像绝不外泄第三方，确保您的隐私安全。"
                    },
                    {
                        "question": "我们的 AI 图像扩展器支持哪些图像格式？",
                        "answer": "支持JPG、PNG、WebP等主流格式，单文件最大10MB，无需预先转换格式。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "什么是AI图像扩展器？",
                    "answer": "基于先进AI算法，此工具可通过智能填充缺失内容扩展图像边界，生成更大尺寸版本，适用于营销、电商、社交媒体发布等多种场景"
                },
                {
                    "question": "为什么要使用我们的 AI 图像扩展器？",
                    "answer": "WeryAI采用最顶尖的AI算法智能分析图像特征，无缝填充周边区域并保持自然高清效果。"
                },
                {
                    "question": "WeryAI AI 图片扩展器可以免费使用吗？",
                    "answer": "可以。新用户注册即可获得免费积分，无需信用卡。你还可以通过每日签到、完成任务和邀请好友获取更多免费积分，因此可以在无需预付费的情况下持续使用该工具。"
                },
                {
                    "question": "我们的 AI 图像扩展器处理照片的速度有多快？",
                    "answer": "通常数秒内完成扩展，无延迟或错误。这使得我们的 AI 扩展图像工具非常适合帮助您处理各种批量图像编辑任务。"
                },
                {
                    "question": "AI图像扩展器会影响分辨率或质量吗？",
                    "answer": "完全不会。工具在扩展过程中保持分辨率、清晰度与细节完整性，个人或专业用途皆可放心使用。"
                },
                {
                    "question": "我上传的图片会保持私密吗？",
                    "answer": "绝对安全！采用行业标准加密技术保障数据隐私，严格政策确保图像绝不外泄第三方，确保您的隐私安全。"
                },
                {
                    "question": "我们的 AI 图像扩展器支持哪些图像格式？",
                    "answer": "支持JPG、PNG、WebP等主流格式，单文件最大10MB，无需预先转换格式。"
                }
            ],
            "feature_title1": "修复缺失细节与背景",
            "feature_desc1": "若您有裁剪过的图片，可通过智能填充缺失细节使画面更完整。工具支持外绘补全功能，甚至能还原老照片中缺失元素，增强画面纪念价值。",
            "feature_title2": "提升产品图质量以促进销售",
            "feature_desc2": "通过AI图像扩展工具扩展产品图周边区域，可添加互补性背景元素。您也可将产品图调整为更宽幅画面，更全面地展示产品细节，从而提升销量。",
            "feature_title3": "创作独特视觉杰作",
            "feature_desc3": "无论您是摄影师、内容创作者还是艺术家，都能通过AI图像扩展工具突破创意边界。扩展原始照片边缘，打造令人惊叹的视觉杰作，将您的构思提升至新高度。",
            "feature_title4": "为社交媒体优化画面比例",
            "feature_desc4": "我们的AI图像扩展工具可将图片扩展至适配Instagram、X（原Twitter）、Facebook等平台的任意比例。工具会智能保持图像清晰度与细节，确保最终效果依然吸睛。",
            "textRemoverHowToUseTitle": "我们的AI图像扩展器如何使用",
            "textRemoverHowToUseDesc": "简单三步，让您的照片突破边界",
            "textRemoverHowToUseStep1Title": "上传图片",
            "textRemoverHowToUseStep1Desc": "点击或拖拽一张您想要扩展的图片。",
            "textRemoverHowToUseStep2Title": "AI 自动处理",
            "textRemoverHowToUseStep2Desc": "上传后，AI 将自动检测并扩展图片的边界。",
            "textRemoverHowToUseStep3Title": "下载扩展后的图片",
            "textRemoverHowToUseStep3Desc": "处理完成后，即可预览/下载一张扩展后的图片！",
            "howto": {
                "name": "如何使用 AI 扩展图片",
                "step1": {
                    "name": "上传照片",
                    "text": "将您想要扩展的照片上传到 WeryAI AI 图片扩展器。"
                },
                "step2": {
                    "name": "选择区域",
                    "text": "选择您想要扩展图片的区域或宽高比。"
                },
                "step3": {
                    "name": "AI 外绘",
                    "text": "点击“创建”。AI 将智能生成新像素并无缝扩展您的图片。"
                }
            }
        }
    },
    "ja": {
        "imgExtender": {
            "title": "無料 AI 画像拡張 - 写真を拡張 | WeryAI",
            "description": "WeryAIの無料AI画像拡張ツールで、写真の元の境界をすぐに広げられます。AIが新しいピクセルを生成してアップロード画像と自然に融合し、人物写真を広角写真にしても元の見た目と画質を保ちます。",
            "keywords": "AI 画像拡張, 無料 画像拡張, 広角写真 生成, 写真 境界 拡張, シームレス 外描き, 画質 維持",
            "og_title": "無料 AI 画像拡張 - 写真を拡張 | WeryAI",
            "og_description": "写真を新しいサイズに拡張し、違和感のない内容を生成します。AI画像拡張ツールを今すぐ無料でお試しください。",
            "twitter_title": "無料 AI 画像拡張 - 写真を拡張 | WeryAI",
            "twitter_description": "写真を新しいサイズに拡張し、違和感のない内容を生成します。AI画像拡張ツールを今すぐ無料でお試しください。",
            "featureList": [
                "AI 画像拡張, 無料 画像拡張, 広角写真 生成, 画質 維持"
            ],
            "page": {
                "title1": "強力なAI画像拡張ツールで驚きの仕上がり",
                "title2": "数クリックで写真の境界を簡単に拡張。AIが新しいピクセルを生成して自然に融合し、人物写真を広角写真にしても元の見た目と画質を保ちます。",
                "feature_title": "WeryAI画像拡張ツールの特長",
                "faq": [
                    {
                        "question": "AI画像拡張ツールとは？",
                        "answer": "高度なAIで、元画像の外側をインテリジェントに補完して境界を拡張するツールです。マーケティング、EC、SNS投稿など幅広い用途に使えます。"
                    },
                    {
                        "question": "なぜWeryAIのAI画像拡張ツールを使うべき？",
                        "answer": "最先端のAIが画像の特徴を分析し、周辺領域を自然で高精細に外描きして違和感なく仕上げます。"
                    },
                    {
                        "question": "無料で使えますか？",
                        "answer": "はい。トライアルクレジットで無料利用できます。コストを抑えて編集ワークフローに組み込めます。"
                    },
                    {
                        "question": "処理速度はどのくらい？",
                        "answer": "通常は数秒で完了します。手早い編集にも、まとめて処理する用途にも最適です。"
                    },
                    {
                        "question": "解像度や画質は落ちますか？",
                        "answer": "いいえ。拡張中も解像度・シャープさ・ディテールを保つよう設計されており、個人/業務用途どちらでも安心です。"
                    },
                    {
                        "question": "アップロードした画像のプライバシーは守られますか？",
                        "answer": "はい。業界標準のセキュリティと厳格なプライバシーポリシーで、第三者への共有を行いません。"
                    },
                    {
                        "question": "対応形式は？",
                        "answer": "JPG/PNG/WebPなど主要形式に対応。最大10MBで、事前変換は不要です。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "AI画像拡張ツールとは？",
                    "answer": "高度なAIで、元画像の外側をインテリジェントに補完して境界を拡張するツールです。マーケティング、EC、SNS投稿など幅広い用途に使えます。"
                },
                {
                    "question": "なぜWeryAIのAI画像拡張ツールを使うべき？",
                    "answer": "最先端のAIが画像の特徴を分析し、周辺領域を自然で高精細に外描きして違和感なく仕上げます。"
                },
                {
                    "question": "無料で使えますか？",
                    "answer": "はい。トライアルクレジットで無料利用できます。コストを抑えて編集ワークフローに組み込めます。"
                },
                {
                    "question": "処理速度はどのくらい？",
                    "answer": "通常は数秒で完了します。手早い編集にも、まとめて処理する用途にも最適です。"
                },
                {
                    "question": "解像度や画質は落ちますか？",
                    "answer": "いいえ。拡張中も解像度・シャープさ・ディテールを保つよう設計されています。"
                },
                {
                    "question": "アップロードした画像のプライバシーは守られますか？",
                    "answer": "はい。業界標準のセキュリティで保護し、第三者へ共有しません。"
                },
                {
                    "question": "対応形式は？",
                    "answer": "JPG/PNG/WebPなど主要形式に対応。最大10MBで、事前変換は不要です。"
                }
            ],
            "feature_title1": "欠けたディテールと背景を補完",
            "feature_desc1": "トリミングされた写真でも、足りない部分を賢く補ってフレームを完成させます。外描き補完で古い写真の欠損要素を復元し、思い出の価値を高めます。",
            "feature_title2": "商品画像の質を上げて売上UP",
            "feature_desc2": "商品写真の周辺を拡張して相性のよい背景要素を追加。よりワイドな構図で商品ディテールを見せ、コンバージョン改善に役立ちます。",
            "feature_title3": "唯一無二のビジュアル作品を創作",
            "feature_desc3": "写真家・クリエイター・アーティストの方も、境界の外側まで拡張して表現の幅を広げ、驚きのビジュアルに仕上げられます。",
            "feature_title4": "SNS向けに比率を最適化",
            "feature_desc4": "Instagram、X（旧Twitter）、Facebookなどに合う任意の比率へ拡張可能。AIがディテールを保ち、最後まで魅力的に仕上げます。",
            "textRemoverHowToUseTitle": "AI画像拡張ツールの使い方",
            "textRemoverHowToUseDesc": "3ステップで写真の境界を拡張",
            "textRemoverHowToUseStep1Title": "画像をアップロード",
            "textRemoverHowToUseStep1Desc": "拡張したい画像をクリックまたはドラッグ＆ドロップします。",
            "textRemoverHowToUseStep2Title": "AIが自動処理",
            "textRemoverHowToUseStep2Desc": "アップロード後、AIが自動で境界を検出して拡張します。",
            "textRemoverHowToUseStep3Title": "拡張画像をダウンロード",
            "textRemoverHowToUseStep3Desc": "処理完了後、プレビューして拡張した画像をダウンロードできます！",
            "howto": {
                "name": "AIで画像を拡張する方法",
                "step1": {
                    "name": "写真をアップロード",
                    "text": "WeryAI AI Image Extenderに拡張したい写真をアップロードします。"
                },
                "step2": {
                    "name": "エリアを選択",
                    "text": "画像を拡張したいエリアまたはアスペクト比を選択します。"
                },
                "step3": {
                    "name": "AIアウトペイント",
                    "text": "「作成」をクリックします。AIがインテリジェントに新しいピクセルを生成し、画像をシームレスに拡張します。"
                }
            }
        }
    },
    "ko": {
        "imgExtender": {
            "title": "무료 AI 이미지 확장 - 사진 아웃페인팅 | WeryAI",
            "description": "WeryAI의 무료 AI 이미지 확장기로 사진의 원래 경계를 즉시 넓혀보세요. AI가 업로드한 이미지와 자연스럽게 이어지는 새 픽셀을 생성해, 인물 사진을 광각 사진으로 확장해도 원본 느낌과 화질을 유지합니다.",
            "keywords": "AI 이미지 확장기, 무료 이미지 확장, 광각 사진 생성, 사진 경계 확장, 자연스러운 아웃페인팅, 원본 화질 유지",
            "og_title": "무료 AI 이미지 확장 - 사진 아웃페인팅 | WeryAI",
            "og_description": "사진을 원하는 새 크기로 확장하고 어울리는 콘텐츠를 생성하세요. AI 이미지 확장기를 지금 무료로 체험해보세요.",
            "twitter_title": "무료 AI 이미지 확장 - 사진 아웃페인팅 | WeryAI",
            "twitter_description": "사진을 원하는 새 크기로 확장하고 어울리는 콘텐츠를 생성하세요. AI 이미지 확장기를 지금 무료로 체험해보세요.",
            "featureList": [
                "AI 이미지 확장기, 무료 이미지 확장, 광각 사진 생성, 원본 화질 유지"
            ],
            "page": {
                "title1": "강력한 AI 이미지 확장기로 놀라운 결과",
                "title2": "몇 번의 클릭만으로 사진의 경계를 손쉽게 확장하세요. AI가 새 픽셀을 생성해 업로드 이미지와 매끄럽게 합성하며, 인물 사진을 광각 사진으로 바꿔도 원본 느낌과 화질을 유지합니다.",
                "feature_title": "WeryAI 이미지 확장기의 특별함",
                "faq": [
                    {
                        "question": "AI 이미지 확장기란 무엇인가요?",
                        "answer": "고급 AI가 이미지 바깥쪽을 지능적으로 채워 경계를 확장하는 도구입니다. 마케팅, 이커머스, SNS 게시물 등 다양한 용도에 적합합니다."
                    },
                    {
                        "question": "왜 WeryAI 이미지 확장기를 사용해야 하나요?",
                        "answer": "최신 AI가 이미지 특징을 분석해 주변 영역을 자연스럽고 고해상도로 아웃페인팅하여 깔끔하게 확장합니다."
                    },
                    {
                        "question": "WeryAI AI 이미지 확장기를 무료로 사용할 수 있나요?",
                        "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있어 선결제 없이도 계속 사용할 수 있습니다."
                    },
                    {
                        "question": "처리 속도는 얼마나 빠른가요?",
                        "answer": "보통 몇 초 내에 완료됩니다. 빠른 편집은 물론 배치 작업에도 적합합니다."
                    },
                    {
                        "question": "해상도나 품질에 영향이 있나요?",
                        "answer": "전혀 없습니다. 확장 과정에서도 해상도, 선명도, 디테일을 유지해 개인/전문 용도 모두 안심하고 사용할 수 있습니다."
                    },
                    {
                        "question": "업로드한 이미지는 안전하게 보호되나요?",
                        "answer": "네. 업계 표준 보안과 엄격한 정책으로 데이터를 보호하며, 이미지를 제3자에게 공유하지 않습니다."
                    },
                    {
                        "question": "어떤 이미지 포맷을 지원하나요?",
                        "answer": "JPG, PNG, WebP 등 주요 포맷을 지원합니다. 단일 파일 최대 10MB이며 변환이 필요 없습니다."
                    }
                ]
            },
            "faq": [
                {
                    "question": "AI 이미지 확장기란 무엇인가요?",
                    "answer": "고급 AI가 이미지 바깥쪽을 지능적으로 채워 경계를 확장하는 도구입니다. 마케팅, 이커머스, SNS 게시물 등 다양한 용도에 적합합니다."
                },
                {
                    "question": "왜 WeryAI 이미지 확장기를 사용해야 하나요?",
                    "answer": "최신 AI가 이미지 특징을 분석해 주변 영역을 자연스럽고 고해상도로 아웃페인팅하여 깔끔하게 확장합니다."
                },
                {
                    "question": "WeryAI AI 이미지 확장기를 무료로 사용할 수 있나요?",
                    "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있어 선결제 없이도 계속 사용할 수 있습니다."
                },
                {
                    "question": "처리 속도는 얼마나 빠른가요?",
                    "answer": "보통 몇 초 내에 완료됩니다."
                },
                {
                    "question": "해상도나 품질에 영향이 있나요?",
                    "answer": "전혀 없습니다. 해상도와 디테일을 유지합니다."
                },
                {
                    "question": "업로드한 이미지는 안전하게 보호되나요?",
                    "answer": "네. 업계 표준 보안으로 보호되며 제3자와 공유되지 않습니다."
                },
                {
                    "question": "어떤 이미지 포맷을 지원하나요?",
                    "answer": "JPG, PNG, WebP 등 주요 포맷 지원(최대 10MB)."
                }
            ],
            "feature_title1": "누락된 디테일과 배경 보완",
            "feature_desc1": "잘린 사진도 부족한 디테일을 지능적으로 채워 화면을 더 완성도 있게 만듭니다. 아웃페인팅으로 오래된 사진의 누락 요소를 복원해 추억의 가치를 높일 수 있어요.",
            "feature_title2": "제품 사진 퀄리티를 높여 판매 촉진",
            "feature_desc2": "제품 사진 주변을 확장해 어울리는 배경 요소를 추가할 수 있습니다. 더 와이드한 구도로 제품 디테일을 보여 판매 전환에 도움을 줍니다.",
            "feature_title3": "독창적인 비주얼 작품 만들기",
            "feature_desc3": "사진가·콘텐츠 크리에이터·아티스트라면, 사진의 가장자리를 확장해 창의적 경계를 넓히고 멋진 비주얼을 완성할 수 있습니다.",
            "feature_title4": "SNS 비율 최적화",
            "feature_desc4": "Instagram, X(구 Twitter), Facebook 등 어떤 비율에도 맞게 확장할 수 있습니다. AI가 선명도와 디테일을 유지해 결과물이 더욱 돋보입니다.",
            "textRemoverHowToUseTitle": "AI 이미지 확장기 사용법",
            "textRemoverHowToUseDesc": "3단계로 사진의 경계를 확장하세요",
            "textRemoverHowToUseStep1Title": "이미지 업로드",
            "textRemoverHowToUseStep1Desc": "확장하고 싶은 이미지를 클릭하거나 드래그 앤 드롭하세요.",
            "textRemoverHowToUseStep2Title": "AI 자동 처리",
            "textRemoverHowToUseStep2Desc": "업로드 후 AI가 자동으로 경계를 감지하고 확장합니다.",
            "textRemoverHowToUseStep3Title": "확장 이미지 다운로드",
            "textRemoverHowToUseStep3Desc": "완료되면 미리보기/다운로드로 확장된 이미지를 저장하세요!",
            "howto": {
                "name": "AI로 이미지 확장하는 방법",
                "step1": {
                    "name": "사진 업로드",
                    "text": "확장하고 싶은 사진을 WeryAI AI 이미지 익스텐더에 업로드하세요."
                },
                "step2": {
                    "name": "영역 선택",
                    "text": "이미지를 확장할 영역이나 화면 비율을 선택하세요."
                },
                "step3": {
                    "name": "AI 아웃페인팅",
                    "text": "'만들기'를 클릭하세요. AI가 지능적으로 새로운 픽셀을 생성하여 이미지를 자연스럽게 확장합니다."
                }
            }
        }
    },
    "es": {
        "imgExtender": {
            "title": "Extender Imágenes con IA Gratis | WeryAI",
            "description": "Con el Extensor de Imágenes con IA gratis de WeryAI, rompe al instante los límites originales de tu foto. Nuestra herramienta genera nuevos píxeles que se integran perfectamente con tu imagen, convirtiendo retratos en tomas gran angulares sin perder el aspecto y la calidad original.",
            "keywords": "extensor de imágenes IA, ampliar imagen gratis, generador de foto gran angular, expandir bordes de foto, outpainting sin costuras, mantener calidad original",
            "og_title": "Extender Imágenes con IA Gratis | WeryAI",
            "og_description": "Amplía tus fotos a nuevos tamaños y genera contenido que encaje. Prueba nuestro Extensor de Imágenes con IA gratis hoy.",
            "twitter_title": "Extender Imágenes con IA Gratis | WeryAI",
            "twitter_description": "Amplía tus fotos a nuevos tamaños y genera contenido que encaje. Prueba nuestro Extensor de Imágenes con IA gratis hoy.",
            "featureList": [
                "extensor de imágenes IA, ampliar imagen gratis, foto gran angular, mantener calidad original"
            ],
            "page": {
                "title1": "Un potente extensor de imágenes con IA, resultados increíbles",
                "title2": "Con solo unos clics, amplía más allá de los bordes originales. Nuestra IA genera nuevos píxeles que se mezclan sin costuras con tu imagen, convirtiendo retratos en fotos gran angulares sin perder calidad.",
                "feature_title": "Por qué el Extensor de Imágenes de WeryAI destaca",
                "faq": [
                    {
                        "question": "¿Qué es un extensor de imágenes con IA?",
                        "answer": "Es una herramienta que usa IA avanzada para ampliar una imagen rellenando de forma inteligente el contenido faltante más allá de sus bordes. Ideal para marketing, e-commerce y redes sociales."
                    },
                    {
                        "question": "¿Por qué usar nuestro extensor de imágenes con IA?",
                        "answer": "WeryAI analiza las características de la imagen y realiza outpainting de manera natural y en alta definición para una extensión sin cortes."
                    },
                    {
                        "question": "¿Puedo usar WeryAI AI Image Extender gratis?",
                        "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta de crédito. También puedes conseguir más créditos gratis con el check-in diario, completando tareas e invitando amigos, así que puedes seguir usando la herramienta sin pagar por adelantado."
                    },
                    {
                        "question": "¿Qué tan rápido es?",
                        "answer": "Normalmente se completa en segundos, perfecto para ediciones rápidas o trabajos por lotes."
                    },
                    {
                        "question": "¿Afecta la resolución o la calidad?",
                        "answer": "No. Mantiene resolución, nitidez y detalles durante la expansión."
                    },
                    {
                        "question": "¿Mis imágenes son privadas?",
                        "answer": "Sí. Usamos seguridad estándar de la industria y políticas estrictas para proteger tu privacidad."
                    },
                    {
                        "question": "¿Qué formatos soporta?",
                        "answer": "JPG, PNG, WebP y formatos comunes. Tamaño máximo por archivo: 10MB. No requiere conversión."
                    }
                ]
            },
            "faq": [
                {
                    "question": "¿Qué es un extensor de imágenes con IA?",
                    "answer": "Es una herramienta que usa IA avanzada para ampliar una imagen rellenando de forma inteligente el contenido faltante más allá de sus bordes. Ideal para marketing, e-commerce y redes sociales."
                },
                {
                    "question": "¿Por qué usar nuestro extensor de imágenes con IA?",
                    "answer": "WeryAI analiza las características de la imagen y realiza outpainting de manera natural y en alta definición para una extensión sin cortes."
                },
                {
                    "question": "¿Puedo usar WeryAI AI Image Extender gratis?",
                    "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta de crédito. También puedes conseguir más créditos gratis con el check-in diario, completando tareas e invitando amigos, así que puedes seguir usando la herramienta sin pagar por adelantado."
                },
                {
                    "question": "¿Qué tan rápido es?",
                    "answer": "Normalmente se completa en segundos."
                },
                {
                    "question": "¿Afecta la resolución o la calidad?",
                    "answer": "No. Mantiene resolución, nitidez y detalles."
                },
                {
                    "question": "¿Mis imágenes son privadas?",
                    "answer": "Sí. Protegemos tus datos con seguridad estándar y políticas estrictas."
                },
                {
                    "question": "¿Qué formatos soporta?",
                    "answer": "JPG, PNG, WebP (máx. 10MB)."
                }
            ],
            "feature_title1": "Repara detalles y fondos faltantes",
            "feature_desc1": "Si tienes una imagen recortada, rellena inteligentemente los detalles faltantes para completar la escena. También sirve para outpainting y restaurar elementos perdidos en fotos antiguas.",
            "feature_title2": "Mejora fotos de producto para vender más",
            "feature_desc2": "Amplía el área alrededor de la foto del producto para añadir fondos complementarios. También puedes crear composiciones más anchas para mostrar más detalles y mejorar conversiones.",
            "feature_title3": "Crea obras visuales únicas",
            "feature_desc3": "Fotógrafos, creadores y artistas pueden ampliar los bordes y llevar sus ideas a un nuevo nivel con resultados sorprendentes.",
            "feature_title4": "Optimiza la proporción para redes sociales",
            "feature_desc4": "Amplía imágenes a cualquier proporción para Instagram, X (antes Twitter), Facebook y más. La IA mantiene la nitidez y los detalles para un resultado llamativo.",
            "textRemoverHowToUseTitle": "Cómo usar nuestro Extensor de Imágenes con IA",
            "textRemoverHowToUseDesc": "3 pasos simples para ampliar tu foto",
            "textRemoverHowToUseStep1Title": "Sube una imagen",
            "textRemoverHowToUseStep1Desc": "Haz clic o arrastra y suelta la imagen que quieres ampliar.",
            "textRemoverHowToUseStep2Title": "Procesamiento automático con IA",
            "textRemoverHowToUseStep2Desc": "Tras subirla, la IA detecta y amplía automáticamente los bordes.",
            "textRemoverHowToUseStep3Title": "Descarga la imagen ampliada",
            "textRemoverHowToUseStep3Desc": "Cuando termine, previsualiza y descarga tu imagen ampliada.",
            "howto": {
                "name": "Cómo extender una imagen con IA",
                "step1": {
                    "name": "Subir foto",
                    "text": "Sube la foto que deseas extender a WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Seleccionar área",
                    "text": "Selecciona el área o la relación de aspecto a la que deseas extender la imagen."
                },
                "step3": {
                    "name": "Outpainting con IA",
                    "text": "Haz clic en 'Crear'. La IA generará píxeles nuevos de forma inteligente y extenderá tu imagen sin problemas."
                }
            }
        }
    },
    "fr": {
        "imgExtender": {
            "title": "Étendre Images par IA Gratuit | WeryAI",
            "description": "Avec l’extenseur d’image IA gratuit de WeryAI, dépassez instantanément les bordures d’origine de vos photos. Notre outil génère de nouveaux pixels parfaitement fusionnés avec votre image pour transformer un portrait en vue grand angle tout en conservant l’apparence et la qualité.",
            "keywords": "extenseur d'image IA, agrandir image gratuit, générateur grand angle, étendre bordures photo, outpainting seamless, préserver la qualité",
            "og_title": "Étendre Images par IA Gratuit | WeryAI",
            "og_description": "Agrandissez vos photos à de nouveaux formats et générez un contenu cohérent. Essayez notre Extenseur d’Image IA gratuitement.",
            "twitter_title": "Étendre Images par IA Gratuit | WeryAI",
            "twitter_description": "Agrandissez vos photos à de nouveaux formats et générez un contenu cohérent. Essayez notre Extenseur d’Image IA gratuitement.",
            "featureList": [
                "extenseur d'image IA, agrandir image gratuit, grand angle, préserver la qualité"
            ],
            "page": {
                "title1": "Un extendeur d’image IA puissant, résultats bluffants",
                "title2": "En quelques clics, étendez votre image au-delà de ses bordures. L’IA génère de nouveaux pixels qui se fondent naturellement avec votre photo pour un rendu grand angle tout en gardant la qualité d’origine.",
                "feature_title": "Ce qui rend l’Extenseur d’Image WeryAI unique",
                "faq": [
                    {
                        "question": "Qu’est-ce qu’un extendeur d’image IA ?",
                        "answer": "C’est un outil qui utilise une IA avancée pour étendre les bords d’une image en complétant intelligemment le contenu manquant. Idéal pour le marketing, l’e-commerce et les réseaux sociaux."
                    },
                    {
                        "question": "Pourquoi utiliser notre extendeur d’image IA ?",
                        "answer": "WeryAI analyse les caractéristiques de l’image et réalise un outpainting naturel en haute définition pour une extension sans raccord visible."
                    },
                    {
                        "question": "Puis-je utiliser WeryAI AI Image Extender gratuitement ?",
                        "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l'inscription, sans carte bancaire. Vous pouvez aussi obtenir plus de crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d'amis, ce qui vous permet de continuer à utiliser l'outil sans paiement anticipé."
                    },
                    {
                        "question": "À quelle vitesse ça fonctionne ?",
                        "answer": "Généralement en quelques secondes, parfait pour des retouches rapides ou en lot."
                    },
                    {
                        "question": "La résolution ou la qualité diminuent-elles ?",
                        "answer": "Non. L’outil préserve la résolution, la netteté et les détails pendant l’extension."
                    },
                    {
                        "question": "Mes images restent-elles privées ?",
                        "answer": "Oui. Nous appliquons une sécurité standard de l’industrie et des politiques strictes pour protéger vos données."
                    },
                    {
                        "question": "Quels formats sont pris en charge ?",
                        "answer": "JPG, PNG, WebP et formats courants. Taille max : 10MB. Aucune conversion requise."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Qu’est-ce qu’un extendeur d’image IA ?",
                    "answer": "C’est un outil qui utilise une IA avancée pour étendre les bords d’une image en complétant intelligemment le contenu manquant. Idéal pour le marketing, l’e-commerce et les réseaux sociaux."
                },
                {
                    "question": "Pourquoi utiliser notre extendeur d’image IA ?",
                    "answer": "WeryAI analyse les caractéristiques de l’image et réalise un outpainting naturel en haute définition pour une extension sans raccord visible."
                },
                {
                    "question": "Puis-je utiliser WeryAI AI Image Extender gratuitement ?",
                    "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l'inscription, sans carte bancaire. Vous pouvez aussi obtenir plus de crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d'amis, ce qui vous permet de continuer à utiliser l'outil sans paiement anticipé."
                },
                {
                    "question": "À quelle vitesse ça fonctionne ?",
                    "answer": "En général en quelques secondes."
                },
                {
                    "question": "La résolution ou la qualité diminuent-elles ?",
                    "answer": "Non. La résolution et les détails sont préservés."
                },
                {
                    "question": "Mes images restent-elles privées ?",
                    "answer": "Oui. Vos données sont protégées et non partagées."
                },
                {
                    "question": "Quels formats sont pris en charge ?",
                    "answer": "JPG, PNG, WebP (10MB max)."
                }
            ],
            "feature_title1": "Réparer des détails et arrière-plans manquants",
            "feature_desc1": "Si votre image a été recadrée, complétez intelligemment les zones manquantes pour une composition plus complète. L’outpainting peut aussi restaurer des éléments perdus sur d’anciennes photos.",
            "feature_title2": "Améliorer les visuels produits pour vendre plus",
            "feature_desc2": "Étendez les zones autour d’un produit pour ajouter un décor cohérent, ou créez un cadrage plus large pour mieux montrer les détails et augmenter les ventes.",
            "feature_title3": "Créer des œuvres visuelles uniques",
            "feature_desc3": "Photographes, créateurs et artistes peuvent repousser les limites et transformer leurs idées en visuels impressionnants.",
            "feature_title4": "Optimiser le format pour les réseaux sociaux",
            "feature_desc4": "Adaptez vos images à n’importe quel ratio pour Instagram, X (ex‑Twitter), Facebook, etc. L’IA conserve netteté et détails pour un résultat accrocheur.",
            "textRemoverHowToUseTitle": "Comment utiliser notre Extenseur d’Image IA",
            "textRemoverHowToUseDesc": "3 étapes simples pour étendre votre photo au‑delà de ses bordures",
            "textRemoverHowToUseStep1Title": "Télécharger une image",
            "textRemoverHowToUseStep1Desc": "Cliquez ou glissez‑déposez l’image que vous souhaitez étendre.",
            "textRemoverHowToUseStep2Title": "Traitement automatique par IA",
            "textRemoverHowToUseStep2Desc": "Après l’envoi, l’IA détecte et étend automatiquement les bordures.",
            "textRemoverHowToUseStep3Title": "Télécharger l’image étendue",
            "textRemoverHowToUseStep3Desc": "Une fois terminé, prévisualisez et téléchargez votre image étendue !",
            "howto": {
                "name": "Comment étendre une image avec l'IA",
                "step1": {
                    "name": "Télécharger la photo",
                    "text": "Téléchargez la photo que vous souhaitez étendre sur WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Sélectionner la zone",
                    "text": "Sélectionnez la zone ou le format d'image vers lequel vous souhaitez étendre l'image."
                },
                "step3": {
                    "name": "Outpainting IA",
                    "text": "Cliquez sur « Créer ». L'IA générera intelligemment de nouveaux pixels et étendra votre image de manière transparente."
                }
            }
        }
    },
    "de": {
        "imgExtender": {
            "title": "KI-Bild-Erweiterer - Fotos Erweitern | WeryAI",
            "description": "Mit WeryAIs kostenlosem KI Bild-Erweiterer sprengen Sie die ursprünglichen Bildränder Ihrer Fotos in Sekunden. Unser Outpainting-Tool erzeugt neue Pixel, die sich nahtlos mit Ihrem Upload verbinden – so werden Porträts zu Weitwinkelbildern, ohne Look und Qualität zu verlieren.",
            "keywords": "KI bild erweitern, bild erweitern kostenlos, weitwinkel foto generator, foto ränder erweitern, nahtloses outpainting, originalqualität behalten",
            "og_title": "KI-Bild-Erweiterer - Fotos Erweitern | WeryAI",
            "og_description": "Erweitern Sie Fotos auf neue Größen und generieren Sie passend ergänzenden Inhalt. Testen Sie unseren KI Bild-Erweiterer kostenlos.",
            "twitter_title": "KI-Bild-Erweiterer - Fotos Erweitern | WeryAI",
            "twitter_description": "Erweitern Sie Fotos auf neue Größen und generieren Sie passend ergänzenden Inhalt. Testen Sie unseren KI Bild-Erweiterer kostenlos.",
            "featureList": [
                "KI bild erweitern, bild erweitern kostenlos, weitwinkel foto, originalqualität behalten"
            ],
            "page": {
                "title1": "Leistungsstarker KI Bild-Erweiterer für beeindruckende Ergebnisse",
                "title2": "Mit wenigen Klicks erweitern Sie Ihr Foto über die ursprünglichen Ränder hinaus. Die KI erzeugt neue Pixel, die perfekt mit dem Upload verschmelzen – für Weitwinkel-Looks bei gleichbleibender Qualität.",
                "feature_title": "Was den WeryAI Bild-Erweiterer besonders macht",
                "faq": [
                    {
                        "question": "Was ist ein KI Bild-Erweiterer?",
                        "answer": "Ein Tool, das mit fortschrittlicher KI Bildränder erweitert, indem es fehlenden Inhalt intelligent ergänzt. Ideal für Marketing, E‑Commerce und Social Media."
                    },
                    {
                        "question": "Warum unseren KI Bild-Erweiterer nutzen?",
                        "answer": "WeryAI analysiert Bildmerkmale und outpaintet die Umgebung natürlich und in hoher Qualität – ohne sichtbare Nähte."
                    },
                    {
                        "question": "Ist der KI Bild-Erweiterer kostenlos?",
                        "answer": "Ja. Sie können ihn mit Test-Credits kostenlos nutzen – eine budgetfreundliche Ergänzung für jeden Bild-Workflow."
                    },
                    {
                        "question": "Wie schnell ist die Erweiterung?",
                        "answer": "In der Regel dauert es nur wenige Sekunden. Ideal für schnelle Edits und Batch-Bearbeitung."
                    },
                    {
                        "question": "Beeinflusst das Auflösung oder Qualität?",
                        "answer": "Nein. Auflösung, Schärfe und Details bleiben während der Erweiterung erhalten."
                    },
                    {
                        "question": "Bleiben meine Uploads privat?",
                        "answer": "Ja. Wir schützen Ihre Daten mit branchenüblicher Sicherheit und strengen Datenschutzrichtlinien."
                    },
                    {
                        "question": "Welche Bildformate werden unterstützt?",
                        "answer": "JPG, PNG, WebP und gängige Formate. Max. Dateigröße: 10MB – keine Konvertierung nötig."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Was ist ein KI Bild-Erweiterer?",
                    "answer": "Ein Tool, das mit fortschrittlicher KI Bildränder erweitert, indem es fehlenden Inhalt intelligent ergänzt. Ideal für Marketing, E‑Commerce und Social Media."
                },
                {
                    "question": "Warum unseren KI Bild-Erweiterer nutzen?",
                    "answer": "WeryAI analysiert Bildmerkmale und outpaintet die Umgebung natürlich und in hoher Qualität – ohne sichtbare Nähte."
                },
                {
                    "question": "Ist der KI Bild-Erweiterer kostenlos?",
                    "answer": "Ja. Kostenlos nutzbar mit Test-Credits."
                },
                {
                    "question": "Wie schnell ist die Erweiterung?",
                    "answer": "Meist in wenigen Sekunden erledigt."
                },
                {
                    "question": "Beeinflusst das Auflösung oder Qualität?",
                    "answer": "Nein. Qualität und Details bleiben erhalten."
                },
                {
                    "question": "Bleiben meine Uploads privat?",
                    "answer": "Ja. Ihre Bilder werden geschützt und nicht an Dritte weitergegeben."
                },
                {
                    "question": "Welche Bildformate werden unterstützt?",
                    "answer": "JPG, PNG, WebP (max. 10MB)."
                }
            ],
            "feature_title1": "Fehlende Details & Hintergründe ergänzen",
            "feature_desc1": "Wenn Ihr Bild zugeschnitten ist, füllt die KI fehlende Bereiche intelligent auf und macht das Motiv vollständiger. Outpainting kann sogar fehlende Elemente in alten Fotos wiederherstellen.",
            "feature_title2": "Produktfotos verbessern und Verkäufe steigern",
            "feature_desc2": "Erweitern Sie den Bereich um Produktbilder, um passende Hintergründe hinzuzufügen. Breitere Kompositionen zeigen mehr Details und können die Conversion erhöhen.",
            "feature_title3": "Einzigartige visuelle Meisterwerke schaffen",
            "feature_desc3": "Ob Fotograf, Creator oder Künstler: Erweitern Sie Bildränder, sprengen Sie kreative Grenzen und verwandeln Sie Ideen in beeindruckende Visuals.",
            "feature_title4": "Seitenverhältnis für Social Media optimieren",
            "feature_desc4": "Erweitern Sie Bilder für jedes Format auf Instagram, X (ehemals Twitter), Facebook und mehr. Die KI hält Details scharf, damit das Ergebnis auffällt.",
            "textRemoverHowToUseTitle": "So nutzen Sie unseren KI Bild-Erweiterer",
            "textRemoverHowToUseDesc": "In 3 einfachen Schritten Foto-Ränder erweitern",
            "textRemoverHowToUseStep1Title": "Bild hochladen",
            "textRemoverHowToUseStep1Desc": "Klicken oder ziehen Sie das Bild per Drag & Drop, das Sie erweitern möchten.",
            "textRemoverHowToUseStep2Title": "KI verarbeitet automatisch",
            "textRemoverHowToUseStep2Desc": "Nach dem Upload erkennt und erweitert die KI automatisch die Bildränder.",
            "textRemoverHowToUseStep3Title": "Erweitertes Bild herunterladen",
            "textRemoverHowToUseStep3Desc": "Nach der Verarbeitung können Sie das Ergebnis ansehen und herunterladen.",
            "howto": {
                "name": "Wie man ein Bild mit KI erweitert",
                "step1": {
                    "name": "Foto hochladen",
                    "text": "Laden Sie das Foto, das Sie erweitern möchten, in den WeryAI AI Image Extender hoch."
                },
                "step2": {
                    "name": "Bereich auswählen",
                    "text": "Wählen Sie den Bereich oder das Seitenverhältnis aus, auf das Sie das Bild erweitern möchten."
                },
                "step3": {
                    "name": "KI Outpainting",
                    "text": "Klicken Sie auf 'Erstellen'. Die KI generiert intelligent neue Pixel und erweitert Ihr Bild nahtlos."
                }
            }
        }
    },
    "ru": {
        "imgExtender": {
            "title": "ИИ Расширение Изображений - Бесплатно | WeryAI",
            "description": "Используйте бесплатный AI расширитель изображений WeryAI, чтобы мгновенно выйти за пределы исходных границ фото. Наш инструмент outpainting генерирует новые пиксели, которые идеально сливаются с исходным изображением — превращайте портреты в широкоугольные кадры, сохраняя стиль и качество.",
            "keywords": "расширить изображение, AI расширитель изображений, расширить фото бесплатно, широкоугольное фото, расширить границы фото, бесшовный outpainting, сохранить качество",
            "og_title": "ИИ Расширение Изображений - Бесплатно | WeryAI",
            "og_description": "Расширяйте фото до новых размеров и генерируйте подходящее окружение. Попробуйте AI расширитель изображений бесплатно.",
            "twitter_title": "ИИ Расширение Изображений - Бесплатно | WeryAI",
            "twitter_description": "Расширяйте фото до новых размеров и генерируйте подходящее окружение. Попробуйте AI расширитель изображений бесплатно.",
            "featureList": [
                "AI расширитель изображений, расширить фото бесплатно, широкоугольный эффект, сохранить качество"
            ],
            "page": {
                "title1": "Мощный AI расширитель изображений для впечатляющих результатов",
                "title2": "Пара кликов — и вы легко расширяете фото за исходные границы. AI создаёт новые пиксели, которые бесшовно смешиваются с загрузкой, сохраняя внешний вид и качество.",
                "feature_title": "Почему WeryAI расширитель изображений особенный",
                "faq": [
                    {
                        "question": "Что такое AI расширитель изображений?",
                        "answer": "Это инструмент, который расширяет границы изображения, интеллектуально дорисовывая недостающий контент за пределами исходного кадра. Подходит для маркетинга, e-commerce и соцсетей."
                    },
                    {
                        "question": "Почему стоит выбрать WeryAI?",
                        "answer": "WeryAI анализирует особенности изображения и естественно дорисовывает окружающую область в высоком качестве без заметных швов."
                    },
                    {
                        "question": "Можно ли пользоваться WeryAI AI Image Extender бесплатно?",
                        "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без необходимости вводить банковскую карту. Вы также можете получать больше бесплатных кредитов за ежедневные отметки, выполнение заданий и приглашение друзей, поэтому инструментом можно пользоваться без предоплаты."
                    },
                    {
                        "question": "Насколько быстро это работает?",
                        "answer": "Обычно расширение занимает несколько секунд — подходит и для быстрых правок, и для пакетной обработки."
                    },
                    {
                        "question": "Пострадает ли качество или разрешение?",
                        "answer": "Нет. Инструмент сохраняет разрешение, чёткость и детали при расширении."
                    },
                    {
                        "question": "Мои изображения будут приватными?",
                        "answer": "Да. Мы используем стандарты безопасности индустрии и строгие политики, чтобы ваши данные не передавались третьим лицам."
                    },
                    {
                        "question": "Какие форматы поддерживаются?",
                        "answer": "JPG, PNG, WebP и другие популярные форматы. Максимальный размер файла — 10MB, конвертация не нужна."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Что такое AI расширитель изображений?",
                    "answer": "Это инструмент, который расширяет границы изображения, интеллектуально дорисовывая недостающий контент за пределами исходного кадра. Подходит для маркетинга, e-commerce и соцсетей."
                },
                {
                    "question": "Почему стоит выбрать WeryAI?",
                    "answer": "WeryAI анализирует особенности изображения и естественно дорисовывает окружающую область в высоком качестве без заметных швов."
                },
                {
                    "question": "Можно ли пользоваться WeryAI AI Image Extender бесплатно?",
                    "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без необходимости вводить банковскую карту. Вы также можете получать больше бесплатных кредитов за ежедневные отметки, выполнение заданий и приглашение друзей, поэтому инструментом можно пользоваться без предоплаты."
                },
                {
                    "question": "Насколько быстро это работает?",
                    "answer": "Обычно за несколько секунд."
                },
                {
                    "question": "Пострадает ли качество или разрешение?",
                    "answer": "Нет. Чёткость и детали сохраняются."
                },
                {
                    "question": "Мои изображения будут приватными?",
                    "answer": "Да. Мы защищаем данные и не делимся ими."
                },
                {
                    "question": "Какие форматы поддерживаются?",
                    "answer": "JPG, PNG, WebP (до 10MB)."
                }
            ],
            "feature_title1": "Восстановление недостающих деталей и фона",
            "feature_desc1": "Если фото было обрезано, AI может дорисовать недостающие области и сделать кадр более цельным. Также подходит для восстановления утраченных элементов на старых фото.",
            "feature_title2": "Улучшайте товарные фото для роста продаж",
            "feature_desc2": "Расширяйте пространство вокруг товара и добавляйте гармоничный фон. Широкие композиции показывают больше деталей и помогают повысить конверсию.",
            "feature_title3": "Создавайте уникальные визуальные шедевры",
            "feature_desc3": "Фотографы, контент‑креаторы и художники могут расширять границы изображения и воплощать идеи в впечатляющих визуалах.",
            "feature_title4": "Оптимизируйте формат для соцсетей",
            "feature_desc4": "Расширяйте изображения под любые пропорции для Instagram, X (бывш. Twitter), Facebook и других платформ. AI сохраняет резкость и детали.",
            "textRemoverHowToUseTitle": "Как пользоваться AI расширителем изображений",
            "textRemoverHowToUseDesc": "3 простых шага, чтобы расширить границы фото",
            "textRemoverHowToUseStep1Title": "Загрузите изображение",
            "textRemoverHowToUseStep1Desc": "Нажмите или перетащите изображение, которое хотите расширить.",
            "textRemoverHowToUseStep2Title": "AI обработает автоматически",
            "textRemoverHowToUseStep2Desc": "После загрузки AI автоматически определит границы и расширит изображение.",
            "textRemoverHowToUseStep3Title": "Скачайте расширенное изображение",
            "textRemoverHowToUseStep3Desc": "После завершения вы сможете просмотреть и скачать расширенную картинку.",
            "howto": {
                "name": "Как расширить изображение с помощью ИИ",
                "step1": {
                    "name": "Загрузить фото",
                    "text": "Загрузите фото, которое хотите расширить, в WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Выбрать область",
                    "text": "Выберите область или соотношение сторон, до которого вы хотите расширить изображение."
                },
                "step3": {
                    "name": "Дорисовка ИИ",
                    "text": "Нажмите «Создать». ИИ интеллектуально сгенерирует новые пиксели и плавно расширит ваше изображение."
                }
            }
        }
    },
    "pt": {
        "imgExtender": {
            "title": "Expandir Imagens com IA Grátis | WeryAI",
            "description": "Use o Extensor de Imagens com IA grátis da WeryAI para ultrapassar instantaneamente as bordas originais da sua foto. Nosso outpainting gera novos pixels que se misturam perfeitamente ao upload — transforme retratos em fotos grande‑angulares mantendo o visual e a qualidade.",
            "keywords": "extensor de imagens IA, expandir imagem grátis, foto grande angular, expandir bordas da foto, outpainting sem marcas, manter qualidade original",
            "og_title": "Expandir Imagens com IA Grátis | WeryAI",
            "og_description": "Expanda suas fotos para novos tamanhos e gere conteúdo que combina com a imagem. Experimente o Extensor de Imagens com IA grátis.",
            "twitter_title": "Expandir Imagens com IA Grátis | WeryAI",
            "twitter_description": "Expanda suas fotos para novos tamanhos e gere conteúdo que combina com a imagem. Experimente o Extensor de Imagens com IA grátis.",
            "featureList": [
                "extensor de imagens IA, expandir imagem grátis, grande angular, manter qualidade"
            ],
            "page": {
                "title1": "Um poderoso Extensor de Imagens com IA, resultados incríveis",
                "title2": "Com poucos cliques, expanda além das bordas originais da foto. A IA gera novos pixels que se integram ao upload, transformando retratos em imagens mais amplas sem perder qualidade.",
                "feature_title": "O que torna o Extensor de Imagens da WeryAI especial",
                "faq": [
                    {
                        "question": "O que é um extensor de imagens com IA?",
                        "answer": "É uma ferramenta que usa IA avançada para expandir as bordas de uma imagem, preenchendo de forma inteligente o conteúdo faltante. Útil para marketing, e‑commerce e redes sociais."
                    },
                    {
                        "question": "Por que usar o Extensor de Imagens da WeryAI?",
                        "answer": "A WeryAI analisa os recursos da imagem e faz outpainting natural em alta definição, com integração sem marcas."
                    },
                    {
                        "question": "É grátis?",
                        "answer": "Sim. Você pode usar gratuitamente com créditos de teste — uma opção econômica para qualquer fluxo de edição."
                    },
                    {
                        "question": "Quão rápido é?",
                        "answer": "Normalmente leva apenas alguns segundos, ideal para edições rápidas e processamento em lote."
                    },
                    {
                        "question": "A expansão afeta a qualidade?",
                        "answer": "Não. Mantém resolução, nitidez e detalhes durante o processo."
                    },
                    {
                        "question": "Minhas imagens ficam privadas?",
                        "answer": "Sim. Protegemos seus dados com segurança padrão da indústria e políticas rígidas de privacidade."
                    },
                    {
                        "question": "Quais formatos são suportados?",
                        "answer": "JPG, PNG, WebP e formatos comuns. Tamanho máximo: 10MB. Sem necessidade de conversão."
                    }
                ]
            },
            "faq": [
                {
                    "question": "O que é um extensor de imagens com IA?",
                    "answer": "É uma ferramenta que usa IA avançada para expandir as bordas de uma imagem, preenchendo de forma inteligente o conteúdo faltante. Útil para marketing, e‑commerce e redes sociais."
                },
                {
                    "question": "Por que usar o Extensor de Imagens da WeryAI?",
                    "answer": "A WeryAI analisa os recursos da imagem e faz outpainting natural em alta definição, com integração sem marcas."
                },
                {
                    "question": "É grátis?",
                    "answer": "Sim. Uso gratuito com créditos de teste."
                },
                {
                    "question": "Quão rápido é?",
                    "answer": "Geralmente em alguns segundos."
                },
                {
                    "question": "A expansão afeta a qualidade?",
                    "answer": "Não. A qualidade e os detalhes são preservados."
                },
                {
                    "question": "Minhas imagens ficam privadas?",
                    "answer": "Sim. Seus dados são protegidos e não compartilhados."
                },
                {
                    "question": "Quais formatos são suportados?",
                    "answer": "JPG, PNG, WebP (até 10MB)."
                }
            ],
            "feature_title1": "Repare detalhes e fundos faltantes",
            "feature_desc1": "Se a imagem foi recortada, preencha áreas faltantes para deixar a cena mais completa. O outpainting também ajuda a recuperar elementos perdidos em fotos antigas.",
            "feature_title2": "Melhore fotos de produto para vender mais",
            "feature_desc2": "Expanda a área ao redor do produto para adicionar fundos complementares. Também dá para criar composições mais largas e mostrar mais detalhes.",
            "feature_title3": "Crie obras visuais únicas",
            "feature_desc3": "Fotógrafos, criadores e artistas podem ultrapassar os limites e transformar ideias em visuais impressionantes.",
            "feature_title4": "Otimize proporções para redes sociais",
            "feature_desc4": "Expanda imagens para qualquer proporção no Instagram, X (antigo Twitter), Facebook e mais. A IA mantém nitidez e detalhes para um resultado chamativo.",
            "textRemoverHowToUseTitle": "Como usar nosso Extensor de Imagens com IA",
            "textRemoverHowToUseDesc": "3 passos simples para expandir sua foto além das bordas",
            "textRemoverHowToUseStep1Title": "Envie uma imagem",
            "textRemoverHowToUseStep1Desc": "Clique ou arraste e solte a imagem que você quer expandir.",
            "textRemoverHowToUseStep2Title": "A IA processa automaticamente",
            "textRemoverHowToUseStep2Desc": "Após o envio, a IA detecta e expande automaticamente as bordas da imagem.",
            "textRemoverHowToUseStep3Title": "Baixe a imagem expandida",
            "textRemoverHowToUseStep3Desc": "Quando terminar, visualize e baixe sua imagem expandida!",
            "howto": {
                "name": "Como estender uma imagem com IA",
                "step1": {
                    "name": "Enviar foto",
                    "text": "Envie a foto que deseja estender para o WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Selecionar área",
                    "text": "Selecione a área ou proporção para a qual deseja estender a imagem."
                },
                "step3": {
                    "name": "Outpainting IA",
                    "text": "Clique em 'Criar'. A IA gerará novos pixels de forma inteligente e estenderá sua imagem perfeitamente."
                }
            }
        }
    },
    "it": {
        "imgExtender": {
            "title": "Estendere Immagini con IA Gratis | WeryAI",
            "description": "Con l’Estensore Immagini con IA gratuito di WeryAI, supera subito i bordi originali della tua foto. Il nostro outpainting genera nuovi pixel che si fondono perfettamente con l’immagine caricata, trasformando ritratti in scatti grandangolari mantenendo aspetto e qualità.",
            "keywords": "estensore immagini IA, espandere immagine gratis, foto grandangolare, estendere bordi foto, outpainting senza giunture, mantenere qualità",
            "og_title": "Estendere Immagini con IA Gratis | WeryAI",
            "og_description": "Espandi le tue foto a nuove dimensioni e genera contenuti coerenti. Prova l’Estensore Immagini con IA gratis.",
            "twitter_title": "Estendere Immagini con IA Gratis | WeryAI",
            "twitter_description": "Espandi le tue foto a nuove dimensioni e genera contenuti coerenti. Prova l’Estensore Immagini con IA gratis.",
            "featureList": [
                "estensore immagini IA, espandere immagine gratis, grandangolo, mantenere qualità"
            ],
            "page": {
                "title1": "Un potente Estensore Immagini con IA, risultati sorprendenti",
                "title2": "Con pochi clic, espandi oltre i bordi originali. L’IA genera nuovi pixel che si fondono con l’upload per un risultato naturale e in alta qualità.",
                "feature_title": "Cosa rende speciale l’Estensore Immagini WeryAI",
                "faq": [
                    {
                        "question": "Cos’è un Estensore Immagini con IA?",
                        "answer": "È uno strumento che usa IA avanzata per estendere i bordi di un’immagine riempiendo in modo intelligente il contenuto mancante. Utile per marketing, e‑commerce e social media."
                    },
                    {
                        "question": "Perché usare il nostro Estensore Immagini con IA?",
                        "answer": "WeryAI analizza le caratteristiche dell’immagine e fa outpainting naturale in alta definizione, senza giunture visibili."
                    },
                    {
                        "question": "È gratis?",
                        "answer": "Sì. Puoi usarlo gratuitamente con crediti di prova: una soluzione economica per qualsiasi workflow."
                    },
                    {
                        "question": "Quanto è veloce?",
                        "answer": "Di solito bastano pochi secondi, ideale per modifiche rapide e batch."
                    },
                    {
                        "question": "Influisce su risoluzione o qualità?",
                        "answer": "No. Mantiene risoluzione, nitidezza e dettagli durante l’espansione."
                    },
                    {
                        "question": "Le mie immagini restano private?",
                        "answer": "Sì. Proteggiamo i dati con sicurezza standard di settore e policy rigorose, senza condivisione con terzi."
                    },
                    {
                        "question": "Quali formati sono supportati?",
                        "answer": "JPG, PNG, WebP e formati comuni. Dimensione massima: 10MB. Nessuna conversione richiesta."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Cos’è un Estensore Immagini con IA?",
                    "answer": "È uno strumento che usa IA avanzata per estendere i bordi di un’immagine riempiendo in modo intelligente il contenuto mancante. Utile per marketing, e‑commerce e social media."
                },
                {
                    "question": "Perché usare il nostro Estensore Immagini con IA?",
                    "answer": "WeryAI analizza le caratteristiche dell’immagine e fa outpainting naturale in alta definizione, senza giunture visibili."
                },
                {
                    "question": "È gratis?",
                    "answer": "Sì. Gratis con crediti di prova."
                },
                {
                    "question": "Quanto è veloce?",
                    "answer": "Di solito in pochi secondi."
                },
                {
                    "question": "Influisce su risoluzione o qualità?",
                    "answer": "No. Qualità e dettagli restano intatti."
                },
                {
                    "question": "Le mie immagini restano private?",
                    "answer": "Sì. I tuoi dati sono protetti e non condivisi."
                },
                {
                    "question": "Quali formati sono supportati?",
                    "answer": "JPG, PNG, WebP (max 10MB)."
                }
            ],
            "feature_title1": "Ripara dettagli e sfondi mancanti",
            "feature_desc1": "Se l’immagine è stata ritagliata, riempi le aree mancanti per rendere la scena più completa. L’outpainting può anche recuperare elementi persi in vecchie foto.",
            "feature_title2": "Migliora foto prodotto per aumentare le vendite",
            "feature_desc2": "Espandi l’area intorno al prodotto per aggiungere elementi di sfondo coerenti. Crea anche composizioni più ampie per mostrare più dettagli.",
            "feature_title3": "Crea capolavori visivi unici",
            "feature_desc3": "Fotografi, creator e artisti possono superare i confini e trasformare le idee in visual sorprendenti.",
            "feature_title4": "Ottimizza i rapporti per i social",
            "feature_desc4": "Espandi immagini per qualsiasi proporzione su Instagram, X (ex Twitter), Facebook e altro. L’IA mantiene nitidezza e dettagli per un risultato che colpisce.",
            "textRemoverHowToUseTitle": "Come usare il nostro Estensore Immagini con IA",
            "textRemoverHowToUseDesc": "3 semplici passi per espandere la tua foto oltre i bordi",
            "textRemoverHowToUseStep1Title": "Carica un’immagine",
            "textRemoverHowToUseStep1Desc": "Clicca o trascina e rilascia l’immagine che vuoi espandere.",
            "textRemoverHowToUseStep2Title": "Elaborazione automatica IA",
            "textRemoverHowToUseStep2Desc": "Dopo il caricamento, l’IA rileva ed estende automaticamente i bordi.",
            "textRemoverHowToUseStep3Title": "Scarica l’immagine espansa",
            "textRemoverHowToUseStep3Desc": "A processo completato, visualizza e scarica l’immagine espansa!",
            "howto": {
                "name": "Come estendere un'immagine con l'IA",
                "step1": {
                    "name": "Carica foto",
                    "text": "Carica la foto che desideri estendere su WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Seleziona area",
                    "text": "Seleziona l'area o il rapporto d'aspetto verso cui desideri estendere l'immagine."
                },
                "step3": {
                    "name": "Outpainting IA",
                    "text": "Fai clic su 'Crea'. L'IA genererà in modo intelligente nuovi pixel ed estenderà la tua immagine senza interruzioni."
                }
            }
        }
    },
    "ar": {
        "imgExtender": {
            "title": "توسيع الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "description": "استخدم موسّع الصور بالذكاء الاصطناعي المجاني من WeryAI لتجاوز حدود الصورة الأصلية فورًا. تقوم الأداة بتوليد بكسلات جديدة تندمج بسلاسة مع الصورة المرفوعة، لتحويل الصور الشخصية إلى لقطات واسعة مع الحفاظ على الشكل والجودة.",
            "keywords": "موسّع صور بالذكاء الاصطناعي, توسيع صورة مجانًا, صورة واسعة, توسيع حدود الصورة, outpainting بسلاسة, الحفاظ على الجودة",
            "og_title": "توسيع الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "og_description": "وسّع صورك إلى أحجام جديدة وولّد محتوى متناسقًا معها. جرّب موسّع الصور بالذكاء الاصطناعي مجانًا اليوم.",
            "twitter_title": "توسيع الصور بالذكاء الاصطناعي مجاناً | WeryAI",
            "twitter_description": "وسّع صورك إلى أحجام جديدة وولّد محتوى متناسقًا معها. جرّب موسّع الصور بالذكاء الاصطناعي مجانًا اليوم.",
            "featureList": [
                "موسّع صور بالذكاء الاصطناعي, توسيع صورة مجانًا, لقطة واسعة, الحفاظ على الجودة"
            ],
            "page": {
                "title1": "موسّع صور قوي بالذكاء الاصطناعي لنتائج مذهلة",
                "title2": "بنقرات بسيطة، وسّع صورتك خارج حدودها الأصلية. يولّد الذكاء الاصطناعي بكسلات جديدة تمتزج بسلاسة مع الصورة، مع الحفاظ على المظهر والجودة.",
                "feature_title": "ما الذي يميز موسّع الصور من WeryAI؟",
                "faq": [
                    {
                        "question": "ما هو موسّع الصور بالذكاء الاصطناعي؟",
                        "answer": "أداة تستخدم ذكاءً اصطناعيًا متقدمًا لتوسيع حدود الصورة عبر ملء المحتوى الناقص خارج الإطار بشكل ذكي. مناسبة للتسويق والتجارة الإلكترونية ومنشورات السوشيال."
                    },
                    {
                        "question": "لماذا أستخدم موسّع الصور من WeryAI؟",
                        "answer": "يحلل WeryAI خصائص الصورة ويقوم بعملية outpainting طبيعية وبجودة عالية دون فواصل واضحة."
                    },
                    {
                        "question": "هل يمكنني استخدام WeryAI AI Image Extender مجانًا؟",
                        "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل من دون الحاجة إلى بطاقة ائتمان. ويمكنك أيضًا الحصول على المزيد من الأرصدة المجانية عبر تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء، لذلك يمكنك مواصلة استخدام الأداة دون دفع مسبق."
                    },
                    {
                        "question": "ما مدى سرعة المعالجة؟",
                        "answer": "غالبًا ما يكتمل خلال ثوانٍ، وهو مناسب للتعديلات السريعة والعمل الدُفعي."
                    },
                    {
                        "question": "هل سيؤثر على الدقة أو الجودة؟",
                        "answer": "لا. يحافظ على الدقة والوضوح والتفاصيل أثناء التوسيع."
                    },
                    {
                        "question": "هل تبقى صوري خاصة؟",
                        "answer": "نعم. نحمي بياناتك بمعايير أمان صناعية وسياسات خصوصية صارمة دون مشاركة مع أطراف ثالثة."
                    },
                    {
                        "question": "ما صيغ الصور المدعومة؟",
                        "answer": "JPG وPNG وWebP وصيغ شائعة أخرى. الحد الأقصى 10MB للملف الواحد ولا حاجة للتحويل."
                    }
                ]
            },
            "faq": [
                {
                    "question": "ما هو موسّع الصور بالذكاء الاصطناعي؟",
                    "answer": "أداة تستخدم ذكاءً اصطناعيًا متقدمًا لتوسيع حدود الصورة عبر ملء المحتوى الناقص خارج الإطار بشكل ذكي. مناسبة للتسويق والتجارة الإلكترونية ومنشورات السوشيال."
                },
                {
                    "question": "لماذا أستخدم موسّع الصور من WeryAI؟",
                    "answer": "يحلل WeryAI خصائص الصورة ويقوم بعملية outpainting طبيعية وبجودة عالية دون فواصل واضحة."
                },
                {
                    "question": "هل يمكنني استخدام WeryAI AI Image Extender مجانًا؟",
                    "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل من دون الحاجة إلى بطاقة ائتمان. ويمكنك أيضًا الحصول على المزيد من الأرصدة المجانية عبر تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء، لذلك يمكنك مواصلة استخدام الأداة دون دفع مسبق."
                },
                {
                    "question": "ما مدى سرعة المعالجة؟",
                    "answer": "عادة خلال ثوانٍ."
                },
                {
                    "question": "هل سيؤثر على الدقة أو الجودة؟",
                    "answer": "لا. تبقى الجودة والتفاصيل محفوظة."
                },
                {
                    "question": "هل تبقى صوري خاصة؟",
                    "answer": "نعم. بياناتك محمية ولا تتم مشاركتها."
                },
                {
                    "question": "ما صيغ الصور المدعومة؟",
                    "answer": "JPG وPNG وWebP (حتى 10MB)."
                }
            ],
            "feature_title1": "إصلاح التفاصيل والخلفيات المفقودة",
            "feature_desc1": "إذا كانت الصورة مقصوصة، يمكن للذكاء الاصطناعي ملء المناطق الناقصة لجعل المشهد أكثر اكتمالًا. كما يساعد outpainting في استعادة عناصر مفقودة في الصور القديمة.",
            "feature_title2": "تحسين صور المنتجات لزيادة المبيعات",
            "feature_desc2": "وسّع المساحة حول صورة المنتج لإضافة خلفية متناسقة. ويمكنك أيضًا إنشاء تكوين أعرض لإظهار تفاصيل أكثر وتعزيز التحويل.",
            "feature_title3": "ابتكر أعمالًا بصرية فريدة",
            "feature_desc3": "سواء كنت مصورًا أو صانع محتوى أو فنانًا، يمكنك تجاوز الحدود الإبداعية وتحويل أفكارك إلى صور مذهلة.",
            "feature_title4": "تحسين نسب الأبعاد للسوشيال",
            "feature_desc4": "وسّع الصور لأي نسبة تناسب Instagram وX (تويتر سابقًا) وFacebook وغيرها. يحافظ الذكاء الاصطناعي على التفاصيل لتبقى النتيجة لافتة.",
            "textRemoverHowToUseTitle": "كيفية استخدام موسّع الصور بالذكاء الاصطناعي",
            "textRemoverHowToUseDesc": "3 خطوات بسيطة لتوسيع صورتك خارج الحدود",
            "textRemoverHowToUseStep1Title": "ارفع صورة",
            "textRemoverHowToUseStep1Desc": "انقر أو اسحب وأفلت الصورة التي تريد توسيعها.",
            "textRemoverHowToUseStep2Title": "معالجة تلقائية بالذكاء الاصطناعي",
            "textRemoverHowToUseStep2Desc": "بعد الرفع، يكتشف الذكاء الاصطناعي الحدود ويقوم بتوسيعها تلقائيًا.",
            "textRemoverHowToUseStep3Title": "نزّل الصورة الموسّعة",
            "textRemoverHowToUseStep3Desc": "بعد الانتهاء، يمكنك معاينة الصورة وتنزيل النسخة الموسّعة.",
            "howto": {
                "name": "كيفية تمديد الصورة بالذكاء الاصطناعي",
                "step1": {
                    "name": "تحميل الصورة",
                    "text": "قم بتحميل الصورة التي تريد تمديدها إلى WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "تحديد المنطقة",
                    "text": "حدد المنطقة أو نسبة العرض إلى الارتفاع التي تريد تمديد الصورة إليها."
                },
                "step3": {
                    "name": "رسم خارجي بالذكاء الاصطناعي",
                    "text": "انقر على 'إنشاء'. سيقوم الذكاء الاصطناعي بذكاء بإنشاء بكسلات جديدة وتمديد صورتك بسلاسة."
                }
            }
        }
    },
    "tw": {
        "imgExtender": {
            "title": "免費 AI 圖片擴展器 - AI 擴圖工具 | WeryAI",
            "description": "想把直圖變橫圖，或把方圖延伸成社群封面？WeryAI 會根據原圖內容自動補邊、延展背景與細節，讓畫面更完整自然。",
            "keywords": "AI 圖片擴展器, 免費圖片擴展, 廣角照片產生器, 擴展照片邊界, 無縫 Outpainting, 保留原始品質",
            "howto": {
                "name": "如何使用 AI 圖片擴展器",
                "step1": {
                    "name": "上傳圖片",
                    "text": "上傳想延展畫面的原始圖片。"
                },
                "step2": {
                    "name": "選擇延展方向或比例",
                    "text": "決定要往左右、上下補邊，或直接選擇目標比例。"
                },
                "step3": {
                    "name": "產生並下載",
                    "text": "AI 完成補邊後即可預覽並下載新圖片。"
                }
            },
            "og_title": "免費 AI 圖片擴展器 - AI 擴圖工具 | WeryAI",
            "og_description": "想把直圖變橫圖，或把方圖延伸成社群封面？WeryAI 會根據原圖內容自動補邊、延展背景與細節，讓畫面更完整自然。",
            "twitter_title": "免費 AI 圖片擴展器 - AI 擴圖工具 | WeryAI",
            "twitter_description": "想把直圖變橫圖，或把方圖延伸成社群封面？WeryAI 會根據原圖內容自動補邊、延展背景與細節，讓畫面更完整自然。",
            "app_name": "WeryAI AI 圖片擴展器",
            "app_desc": "利用 AI 自動延伸圖片邊界、補全背景與畫面細節，讓一張圖更容易適配不同尺寸與版位。",
            "featureList": [
                "AI 圖片擴展器, 免費圖片擴展, 廣角照片產生器, 擴展照片邊界, 無縫 Outpainting, 保留原始品質"
            ],
            "page": {
                "title1": "AI 圖片擴展器，讓畫面自然延伸不裁切",
                "title2": "只要幾秒鐘，AI 就能依照原圖風格補齊邊界與背景，把人物照、商品圖或社群素材延展成更完整的大畫面。",
                "feature_title": "為什麼選擇 WeryAI 圖片擴展器？",
                "faq": [
                    {
                        "question": "什麼是 AI 圖片擴展器？",
                        "answer": "它能根據原始圖片內容，自動補出邊界外的背景與細節，讓畫面在不裁切主體的情況下延展到更大的尺寸。"
                    },
                    {
                        "question": "適合拿來做社群比例調整嗎？",
                        "answer": "非常適合。你可以把方圖延伸成直幅、橫幅或封面尺寸，減少反覆裁切造成的構圖破壞。"
                    },
                    {
                        "question": "AI 補出的背景會很假嗎？",
                        "answer": "模型會參考原圖的光線、色彩與紋理來延展畫面，讓新增區域與原圖自然銜接。"
                    },
                    {
                        "question": "可以拿來擴展商品圖嗎？",
                        "answer": "可以。無論是產品主圖、海報還是場景照，都能利用 AI 補邊創造更完整的展示空間。"
                    },
                    {
                        "question": "我的圖片會被保存嗎？",
                        "answer": "我們重視你的隱私，圖片僅用於當前處理流程，不會任意對外分享。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "什麼是 AI 圖片擴展器？",
                    "answer": "它能根據原始圖片內容，自動補出邊界外的背景與細節，讓畫面在不裁切主體的情況下延展到更大的尺寸。"
                },
                {
                    "question": "適合拿來做社群比例調整嗎？",
                    "answer": "非常適合。你可以把方圖延伸成直幅、橫幅或封面尺寸，減少反覆裁切造成的構圖破壞。"
                },
                {
                    "question": "AI 補出的背景會很假嗎？",
                    "answer": "模型會參考原圖的光線、色彩與紋理來延展畫面，讓新增區域與原圖自然銜接。"
                },
                {
                    "question": "可以拿來擴展商品圖嗎？",
                    "answer": "可以。無論是產品主圖、海報還是場景照，都能利用 AI 補邊創造更完整的展示空間。"
                },
                {
                    "question": "我的圖片會被保存嗎？",
                    "answer": "我們重視你的隱私，圖片僅用於當前處理流程，不會任意對外分享。"
                }
            ],
            "feature_title1": "智慧補邊與背景延展",
            "feature_desc1": "AI 會根據原圖風格補出自然的背景與細節，讓新增畫面不顯突兀。",
            "feature_title2": "主體不裁切，構圖更完整",
            "feature_desc2": "不需要犧牲人物、產品或關鍵元素，就能把原圖延展到新的比例與版位。",
            "feature_title3": "適配社群、廣告與電商尺寸",
            "feature_desc3": "方圖、直圖、橫幅與封面都能快速生成，方便內容跨平台重用。",
            "feature_title4": "細節清晰，維持原有質感",
            "feature_desc4": "在延展畫面時盡量保留原圖的清晰度、光線與質感，減少生硬感。",
            "textRemoverHowToUseTitle": "如何使用 AI 圖片擴展器",
            "textRemoverHowToUseDesc": "三步就能把圖片延伸成更適合發布的大畫面",
            "textRemoverHowToUseStep1Title": "上傳圖片",
            "textRemoverHowToUseStep1Desc": "上傳想延展畫面的原始圖片。",
            "textRemoverHowToUseStep2Title": "選擇延展方向或比例",
            "textRemoverHowToUseStep2Desc": "決定要往左右、上下補邊，或直接選擇目標比例。",
            "textRemoverHowToUseStep3Title": "產生並下載",
            "textRemoverHowToUseStep3Desc": "AI 完成補邊後即可預覽並下載新圖片。",
            "desc": "三步就能把圖片延伸成更適合發布的大畫面"
        }
    },
    "pl": {
        "imgExtender": {
            "title": "Darmowy AI Rozszerzacz Obrazu - Outpainting Zdjęć | WeryAI",
            "description": "Rozszerzaj obrazy poza oryginalne granice dzięki AI outpainting. Generuj spójną zawartość dopasowaną do sceny. Darmowe kredyty przy rejestracji, bez karty.",
            "keywords": "AI rozszerzacz obrazu, outpainting zdjęć, rozszerzanie zdjęć, poszerzanie obrazu, generatywne wypełnianie, WeryAI",
            "og_title": "Darmowy AI Rozszerzacz Obrazu - Outpainting Zdjęć | WeryAI",
            "og_description": "Rozszerzaj obrazy poza oryginalne granice dzięki AI outpainting. Generuj spójną zawartość dopasowaną do sceny.",
            "twitter_title": "Darmowy AI Rozszerzacz Obrazu - Outpainting Zdjęć | WeryAI",
            "twitter_description": "Rozszerzaj obrazy poza oryginalne granice dzięki AI outpainting. Generuj spójną zawartość dopasowaną do sceny.",
            "featureList": [
                "AI rozszerzacz obrazu, darmowe rozszerzanie, outpainting zdjęć, zachowanie jakości"
            ],
            "page": {
                "title1": "Potężny AI Rozszerzacz Obrazu dla wyjątkowych rezultatów",
                "title2": "Kilkoma kliknięciami rozszerz obraz poza oryginalne granice. AI generuje nowe piksele, które płynnie łączą się z Twoim zdjęciem — zmień portret w panoramiczne ujęcie, zachowując oryginalny wygląd i jakość.",
                "feature_title": "Co wyróżnia WeryAI Rozszerzacz Obrazu | WeryAI",
                "faq": [
                    {
                        "question": "Czym jest AI Rozszerzacz Obrazu?",
                        "answer": "To narzędzie oparte na zaawansowanej AI, które rozszerza obraz, inteligentnie wypełniając brakujące obszary poza oryginalnymi granicami. Tworzy większą wersję zdjęcia — idealne do marketingu, e-commerce i mediów społecznościowych. Potrzebujesz zmienić rozmiar? Wypróbuj nasz <a href=\"/ai-image-resizer\">Image Resizer</a>."
                    },
                    {
                        "question": "Dlaczego warto wybrać WeryAI?",
                        "answer": "WeryAI wykorzystuje najnowocześniejsze modele do analizy cech obrazu i płynnego outpaintingu otaczających obszarów z naturalnym, wysokiej rozdzielczości rezultatem."
                    },
                    {
                        "question": "Czy mogę używać za darmo?",
                        "answer": "Tak! Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji — bez karty kredytowej. Zdobywaj więcej codziennie dzięki check-inowi, wykonywaniu zadań i zapraszaniu znajomych."
                    },
                    {
                        "question": "Jak szybko działa AI Rozszerzacz Obrazu?",
                        "answer": "Zwykle zajmuje to kilka sekund. Idealne zarówno do szybkich edycji, jak i przetwarzania wsadowego."
                    },
                    {
                        "question": "Czy wpłynie to na rozdzielczość lub jakość?",
                        "answer": "Nie. Narzędzie zachowuje rozdzielczość, ostrość i detale podczas rozszerzania — bezpieczne do użytku osobistego i profesjonalnego."
                    },
                    {
                        "question": "Czy moje zdjęcia pozostaną prywatne?",
                        "answer": "Tak. Chronimy Twoje dane z zastosowaniem standardów branżowych i ścisłych zasad prywatności — zdjęcia nie są udostępniane osobom trzecim."
                    },
                    {
                        "question": "Jakie formaty obrazów są obsługiwane?",
                        "answer": "JPG, PNG, WebP i inne popularne formaty. Maksymalny rozmiar pliku to 10 MB — konwersja nie jest wymagana."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Czym jest AI Rozszerzacz Obrazu?",
                    "answer": "Narzędzie oparte na AI, które rozszerza obraz, inteligentnie wypełniając brakujące obszary poza oryginalnymi granicami. Idealne do marketingu, e-commerce i mediów społecznościowych."
                },
                {
                    "question": "Dlaczego warto wybrać WeryAI?",
                    "answer": "Najnowocześniejsze modele AI analizują cechy obrazu i płynnie outpaintują otaczające obszary z naturalnym rezultatem."
                },
                {
                    "question": "Czy mogę używać za darmo?",
                    "answer": "Tak! Darmowe kredyty przy rejestracji, bez karty. Zdobywaj więcej przez check-in, zadania i zaproszenia."
                },
                {
                    "question": "Jak szybko działa?",
                    "answer": "Zwykle kilka sekund — idealne do szybkich edycji i przetwarzania wsadowego."
                },
                {
                    "question": "Czy jakość zostanie zachowana?",
                    "answer": "Tak. Rozdzielczość, ostrość i detale są zachowywane podczas rozszerzania."
                },
                {
                    "question": "Czy moje dane są bezpieczne?",
                    "answer": "Tak. Stosujemy standardy branżowe bezpieczeństwa i nie udostępniamy zdjęć osobom trzecim."
                },
                {
                    "question": "Jakie formaty są obsługiwane?",
                    "answer": "JPG, PNG, WebP i inne popularne formaty (maks. 10 MB)."
                }
            ],
            "feature_title1": "Odtwarzanie brakujących detali i tła",
            "feature_desc1": "Jeśli Twoje zdjęcie zostało przycięte, AI inteligentnie uzupełni brakujące detale i dopełni kadr. Outpainting przywraca utracone elementy starych zdjęć i odzyskuje cenne wspomnienia.",
            "feature_title2": "Rozszerzanie panoram i krajobrazów",
            "feature_desc2": "Poszerzaj krawędzie zdjęć krajobrazowych i panoramicznych, tworząc szerokie kompozycje z doskonale dopasowanym tłem.",
            "feature_title3": "Gotowe do e-commerce i marketingu",
            "feature_desc3": "Rozszerzaj przestrzeń wokół produktów, aby dodać naturalny kontekst. Twórz szersze kadry prezentujące więcej szczegółów produktu i zwiększaj konwersje.",
            "feature_title4": "Optymalizuj proporcje dla mediów społecznościowych",
            "feature_desc4": "Rozszerzaj obrazy do dowolnych proporcji dla Instagrama, X (dawniej Twittera), Facebooka i innych. AI zachowuje ostrość detali, dzięki czemu efekt końcowy przyciąga wzrok.",
            "textRemoverHowToUseTitle": "Jak korzystać z naszego AI Rozszerzacza Obrazu",
            "textRemoverHowToUseDesc": "3 proste kroki, aby rozszerzyć zdjęcie poza jego granice",
            "textRemoverHowToUseStep1Title": "Prześlij obraz",
            "textRemoverHowToUseStep1Desc": "Kliknij lub przeciągnij i upuść obraz, który chcesz rozszerzyć.",
            "textRemoverHowToUseStep2Title": "AI automatycznie przetwarza",
            "textRemoverHowToUseStep2Desc": "Po przesłaniu AI automatycznie wykryje i rozszerzy granice obrazu.",
            "textRemoverHowToUseStep3Title": "Pobierz rozszerzony obraz",
            "textRemoverHowToUseStep3Desc": "Gdy będzie gotowy, podejrzyj i pobierz swój rozszerzony obraz!",
            "howto": {
                "name": "Jak rozszerzyć obraz za pomocą AI",
                "step1": {
                    "name": "Prześlij zdjęcie",
                    "text": "Prześlij zdjęcie, które chcesz rozszerzyć do WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Wybierz obszar",
                    "text": "Wybierz obszar lub proporcje, do których chcesz rozszerzyć obraz."
                },
                "step3": {
                    "name": "Outpainting AI",
                    "text": "Kliknij 'Utwórz'. AI inteligentnie wygeneruje nowe piksele i płynnie rozszerzy Twój obraz."
                }
            }
        }
    },
    "th": {
        "imgExtender": {
            "title": "ขยายรูปภาพ AI ฟรี - Outpaint ภาพถ่าย | WeryAI",
            "description": "ขยายภาพเกินขอบเดิมด้วย AI Outpainting สร้างเนื้อหาต่อเนื่องที่กลมกลืนกับฉากต้นฉบับ เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต",
            "keywords": "AI ขยายภาพ, outpainting, ขยายภาพถ่าย, เติมภาพ, generative fill, WeryAI",
            "og_title": "ขยายรูปภาพ AI ฟรี - Outpaint ภาพถ่าย | WeryAI",
            "og_description": "ขยายภาพเกินขอบเดิมด้วย AI Outpainting สร้างเนื้อหาต่อเนื่องที่กลมกลืนกับฉากต้นฉบับ",
            "twitter_title": "ขยายรูปภาพ AI ฟรี - Outpaint ภาพถ่าย | WeryAI",
            "twitter_description": "ขยายภาพเกินขอบเดิมด้วย AI Outpainting สร้างเนื้อหาต่อเนื่องที่กลมกลืนกับฉากต้นฉบับ",
            "featureList": [
                "AI ขยายภาพ, ขยายภาพฟรี, outpainting, รักษาคุณภาพต้นฉบับ"
            ],
            "page": {
                "title1": "เครื่องมือขยายภาพ AI ทรงพลัง ผลลัพธ์น่าทึ่ง",
                "title2": "แค่ไม่กี่คลิก ขยายภาพเกินขอบเดิมได้ทันที AI สร้างพิกเซลใหม่ที่กลมกลืนกับภาพต้นฉบับ — เปลี่ยนภาพพอร์ตเทรตเป็นภาพมุมกว้างโดยรักษาคุณภาพเดิมไว้",
                "feature_title": "อะไรทำให้ WeryAI เครื่องมือขยายภาพพิเศษ | WeryAI",
                "faq": [
                    {
                        "question": "AI ขยายภาพคืออะไร?",
                        "answer": "เครื่องมือที่ใช้ AI ขั้นสูงขยายภาพโดยเติมเนื้อหาที่ขาดหายไปเกินขอบต้นฉบับ สร้างเวอร์ชันที่ใหญ่ขึ้นของภาพ เหมาะกับการตลาด อีคอมเมิร์ซ และโซเชียลมีเดีย ต้องการปรับขนาด? ลอง <a href=\"/ai-image-resizer\">Image Resizer</a>"
                    },
                    {
                        "question": "ทำไมต้องเลือก WeryAI?",
                        "answer": "WeryAI ใช้โมเดลล่าสุดวิเคราะห์คุณลักษณะของภาพและ outpaint พื้นที่โดยรอบอย่างแนบเนียนด้วยผลลัพธ์ธรรมชาติและความละเอียดสูง"
                    },
                    {
                        "question": "ใช้งานฟรีได้ไหม?",
                        "answer": "ได้! ผู้ใช้ใหม่ได้เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต รับเครดิตเพิ่มได้ทุกวันผ่านเช็คอิน ทำภารกิจ และเชิญเพื่อน"
                    },
                    {
                        "question": "AI ขยายภาพเร็วแค่ไหน?",
                        "answer": "ปกติเสร็จภายในไม่กี่วินาที เหมาะทั้งแก้ไขด่วนและงานประมวลผลจำนวนมาก"
                    },
                    {
                        "question": "จะกระทบความละเอียดหรือคุณภาพไหม?",
                        "answer": "ไม่ เครื่องมือรักษาความละเอียด ความคมชัด และรายละเอียดระหว่างการขยาย — ปลอดภัยสำหรับใช้ส่วนตัวและเชิงพาณิชย์"
                    },
                    {
                        "question": "ภาพที่อัปโหลดจะเป็นส่วนตัวไหม?",
                        "answer": "ปลอดภัย เราปกป้องข้อมูลด้วยมาตรฐานอุตสาหกรรมและนโยบายความเป็นส่วนตัวที่เข้มงวด ภาพจะไม่ถูกแชร์กับบุคคลที่สาม"
                    },
                    {
                        "question": "รองรับไฟล์รูปแบบใดบ้าง?",
                        "answer": "รองรับ JPG, PNG, WebP และรูปแบบทั่วไปอื่นๆ ขนาดไฟล์สูงสุด 10 MB ไม่ต้องแปลงไฟล์"
                    }
                ]
            },
            "faq": [
                {
                    "question": "AI ขยายภาพคืออะไร?",
                    "answer": "เครื่องมือ AI ที่ขยายภาพโดยเติมเนื้อหาเกินขอบต้นฉบับอย่างชาญฉลาด เหมาะกับการตลาด อีคอมเมิร์ซ และโซเชียลมีเดีย"
                },
                {
                    "question": "ทำไมต้องเลือก WeryAI?",
                    "answer": "โมเดล AI ล่าสุดวิเคราะห์ภาพและ outpaint อย่างแนบเนียน ให้ผลลัพธ์ธรรมชาติคมชัด"
                },
                {
                    "question": "ใช้งานฟรีได้ไหม?",
                    "answer": "ได้! เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตร รับเพิ่มผ่านเช็คอิน ภารกิจ และเชิญเพื่อน"
                },
                {
                    "question": "เร็วแค่ไหน?",
                    "answer": "ปกติไม่กี่วินาที เหมาะทั้งแก้ไขด่วนและงานจำนวนมาก"
                },
                {
                    "question": "คุณภาพจะลดลงไหม?",
                    "answer": "ไม่ รักษาความละเอียดและรายละเอียดระหว่างการขยาย"
                },
                {
                    "question": "ข้อมูลปลอดภัยไหม?",
                    "answer": "ปลอดภัย ใช้มาตรฐานอุตสาหกรรมและไม่แชร์ภาพกับบุคคลที่สาม"
                },
                {
                    "question": "รองรับรูปแบบไฟล์ใดบ้าง?",
                    "answer": "JPG, PNG, WebP และรูปแบบทั่วไป (สูงสุด 10 MB)"
                }
            ],
            "feature_title1": "กู้คืนรายละเอียดและพื้นหลังที่หายไป",
            "feature_desc1": "หากภาพถูกครอป AI จะเติมรายละเอียดที่ขาดหายอย่างชาญฉลาดเพื่อทำให้กรอบภาพสมบูรณ์ รองรับ outpainting เพื่อกู้คืนส่วนที่หายไปในภาพเก่าและเรียกคืนความทรงจำอันมีค่า",
            "feature_title2": "ขยายภาพทิวทัศน์และพาโนรามา",
            "feature_desc2": "ขยายขอบภาพทิวทัศน์และพาโนรามาเพื่อสร้างภาพกว้างที่มีพื้นหลังกลมกลืนอย่างสมบูรณ์แบบ",
            "feature_title3": "พร้อมสำหรับอีคอมเมิร์ซและการตลาด",
            "feature_desc3": "ขยายพื้นที่รอบภาพสินค้าเพื่อเพิ่มบริบทธรรมชาติ สร้างภาพกว้างขึ้นเพื่อแสดงรายละเอียดสินค้ามากขึ้นและเพิ่มอัตราการแปลง",
            "feature_title4": "ปรับสัดส่วนภาพให้เหมาะกับโซเชียลมีเดีย",
            "feature_desc4": "ขยายภาพให้พอดีกับทุกสัดส่วนสำหรับ Instagram, X (เดิมคือ Twitter), Facebook และอื่นๆ AI รักษาความคมชัดของรายละเอียดเพื่อให้ผลลัพธ์สุดท้ายยังคงดึงดูดสายตา",
            "textRemoverHowToUseTitle": "วิธีใช้เครื่องมือ AI ขยายภาพของเรา",
            "textRemoverHowToUseDesc": "3 ขั้นตอนง่ายๆ เพื่อขยายภาพถ่ายเกินขอบเดิม",
            "textRemoverHowToUseStep1Title": "อัปโหลดรูปภาพ",
            "textRemoverHowToUseStep1Desc": "คลิกหรือลากและวางรูปภาพที่คุณต้องการขยาย",
            "textRemoverHowToUseStep2Title": "AI ประมวลผลอัตโนมัติ",
            "textRemoverHowToUseStep2Desc": "หลังจากอัปโหลด AI จะตรวจจับและขยายขอบภาพโดยอัตโนมัติ",
            "textRemoverHowToUseStep3Title": "ดาวน์โหลดภาพที่ขยายแล้ว",
            "textRemoverHowToUseStep3Desc": "เมื่อพร้อมแล้ว ดูตัวอย่างและดาวน์โหลดภาพที่ขยายแล้วได้เลย!",
            "howto": {
                "name": "วิธีขยายรูปภาพด้วย AI",
                "step1": {
                    "name": "อัปโหลดรูปภาพ",
                    "text": "อัปโหลดรูปภาพที่คุณต้องการขยายไปที่ WeryAI AI Image Extender"
                },
                "step2": {
                    "name": "เลือกพื้นที่",
                    "text": "เลือกพื้นที่หรือสัดส่วนภาพที่คุณต้องการขยายรูปภาพ"
                },
                "step3": {
                    "name": "AI Outpaint",
                    "text": "คลิก 'สร้าง' AI จะสร้างพิกเซลใหม่อย่างชาญฉลาดและขยายรูปภาพของคุณอย่างแนบเนียน"
                }
            }
        }
    },
    "da": {
        "imgExtender": {
            "title": "Gratis AI Billedudvider - Outpaint Fotos | WeryAI",
            "description": "Udvid billeder ud over de originale kanter med AI outpainting. Generer sømløst indhold, der passer til den originale scene. Gratis credits ved tilmelding.",
            "keywords": "AI billedudvider, outpainting, udvid billede, billedudvidelse, generativ udfyldning, WeryAI",
            "og_title": "Gratis AI Billedudvider - Outpaint Fotos | WeryAI",
            "og_description": "Udvid billeder ud over de originale kanter med AI outpainting. Generer sømløst indhold, der passer til den originale scene.",
            "twitter_title": "Gratis AI Billedudvider - Outpaint Fotos | WeryAI",
            "twitter_description": "Udvid billeder ud over de originale kanter med AI outpainting. Generer sømløst indhold, der passer til den originale scene.",
            "featureList": [
                "AI billedudvider, gratis billedudvidelse, outpainting, bevar kvaliteten"
            ],
            "page": {
                "title1": "Kraftfuld AI Billedudvider for fantastiske resultater",
                "title2": "Med få klik kan du udvide dit foto ud over de originale kanter. Vores AI genererer nye pixels, der smelter sømløst sammen med dit upload — forvandl portrætter til vidvinkelbilleder, mens det originale udseende og kvaliteten bevares.",
                "faq": [
                    {
                        "question": "Hvad er en AI Billedudvider?",
                        "answer": "Et værktøj drevet af avanceret AI, der udvider et billede ved intelligent at udfylde manglende områder ud over de originale grænser. Det skaber en større version af dit foto — fantastisk til marketing, e-handel og sociale medier. Har du brug for at ændre størrelse? Prøv vores <a href=\"/ai-image-resizer\">Image Resizer</a>."
                    },
                    {
                        "question": "Hvorfor vælge WeryAI?",
                        "answer": "WeryAI bruger avancerede modeller til at analysere billedets egenskaber og sømløst outpainte de omkringliggende områder med naturlige resultater i høj opløsning."
                    },
                    {
                        "question": "Kan jeg bruge det gratis?",
                        "answer": "Ja! Nye brugere får gratis credits ved tilmelding — intet kreditkort nødvendigt. Tjen flere dagligt via check-in, opgaver og ved at invitere venner."
                    },
                    {
                        "question": "Hvor hurtigt er AI Billedudvideren?",
                        "answer": "Det tager normalt få sekunder. Ideel til både hurtige redigeringer og batchbehandling."
                    },
                    {
                        "question": "Påvirkes opløsning eller kvalitet?",
                        "answer": "Nej. Værktøjet bevarer opløsning, skarphed og detaljer under udvidelsen — sikkert til personlig og professionel brug."
                    },
                    {
                        "question": "Forbliver mine billeder private?",
                        "answer": "Ja. Vi beskytter dine data med branchestandard sikkerhed og strenge privatlivspolitikker — dine billeder deles ikke med tredjeparter."
                    },
                    {
                        "question": "Hvilke billedformater understøttes?",
                        "answer": "JPG, PNG, WebP og andre almindelige formater. Maks. filstørrelse er 10 MB — ingen konvertering nødvendig."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hvad er en AI Billedudvider?",
                    "answer": "Et AI-værktøj der udvider billeder ved at udfylde manglende indhold ud over de originale grænser. Ideelt til marketing, e-handel og sociale medier."
                },
                {
                    "question": "Hvorfor vælge WeryAI?",
                    "answer": "Avancerede AI-modeller analyserer billedet og outpainter de omkringliggende områder med naturlige, højtopløselige resultater."
                },
                {
                    "question": "Kan jeg bruge det gratis?",
                    "answer": "Ja! Gratis credits ved tilmelding, intet kort nødvendigt. Tjen flere via check-in, opgaver og invitationer."
                },
                {
                    "question": "Hvor hurtigt?",
                    "answer": "Normalt få sekunder — perfekt til hurtige redigeringer og batchbehandling."
                },
                {
                    "question": "Bevares kvaliteten?",
                    "answer": "Ja. Opløsning, skarphed og detaljer bevares under udvidelsen."
                },
                {
                    "question": "Er mine data sikre?",
                    "answer": "Ja. Branchestandard sikkerhed og strenge privatlivspolitikker — ingen deling med tredjeparter."
                },
                {
                    "question": "Hvilke formater?",
                    "answer": "JPG, PNG, WebP og andre almindelige formater (maks. 10 MB)."
                }
            ],
            "feature_title1": "Gendan manglende detaljer og baggrund",
            "feature_desc1": "Hvis dit foto er beskåret, udfylder AI intelligent de manglende detaljer for at gøre rammen komplet. Outpainting gendanner mistede elementer i gamle fotos og bringer værdifulde minder tilbage.",
            "feature_title2": "Udvid landskaber og panoramaer",
            "feature_desc2": "Udvid kanterne på landskabs- og panoramabilleder for at skabe brede kompositioner med perfekt matchende baggrunde.",
            "feature_title3": "Klar til e-handel og markedsføring",
            "feature_desc3": "Udvid området omkring produktbilleder for at tilføje naturlig kontekst. Skab bredere kompositioner, der viser flere produktdetaljer og øger konverteringer.",
            "howto": {
                "name": "Sådan udvider du et billede med AI",
                "step1": {
                    "name": "Upload foto",
                    "text": "Upload det foto, du vil udvide, til WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Vælg område",
                    "text": "Vælg det område eller billedformat, du vil udvide billedet til."
                },
                "step3": {
                    "name": "AI Outpainting",
                    "text": "Klik på 'Opret'. AI'en vil intelligent generere nye pixels og problemfrit udvide dit billede."
                }
            }
        }
    },
    "no": {
        "imgExtender": {
            "title": "Gratis AI Bildeutvider - Outpaint Bilder | WeryAI",
            "description": "Utvid bilder utover de opprinnelige kantene med AI outpainting. Generer sømløst innhold som matcher den originale scenen. Gratis kreditter ved registrering.",
            "keywords": "AI bildeutvider, outpainting, utvide bilde, bildeutvidelse, generativ utfylling, WeryAI",
            "og_title": "Gratis AI Bildeutvider - Outpaint Bilder | WeryAI",
            "og_description": "Utvid bilder utover de opprinnelige kantene med AI outpainting. Generer sømløst innhold som matcher den originale scenen.",
            "twitter_title": "Gratis AI Bildeutvider - Outpaint Bilder | WeryAI",
            "twitter_description": "Utvid bilder utover de opprinnelige kantene med AI outpainting. Generer sømløst innhold som matcher den originale scenen.",
            "featureList": [
                "AI bildeutvider, gratis bildeutvidelse, outpainting, bevare kvaliteten"
            ],
            "page": {
                "title1": "Kraftig AI Bildeutvider for fantastiske resultater",
                "title2": "Med noen få klikk kan du utvide bildet ditt utover de originale kantene. Vår AI genererer nye piksler som smelter sømløst sammen med opplastingen — gjør portretter om til vidvinkelbilder mens det opprinnelige utseendet og kvaliteten bevares.",
                "feature_title": "Hva gjør WeryAI Bildeutvider spesiell | WeryAI",
                "faq": [
                    {
                        "question": "Hva er en AI Bildeutvider?",
                        "answer": "Et verktøy drevet av avansert AI som utvider et bilde ved intelligent utfylling av manglende områder utenfor de opprinnelige grensene. Det skaper en større versjon av bildet ditt — perfekt for markedsføring, e-handel og sosiale medier. Trenger du å endre størrelse? Prøv vår <a href=\"/ai-image-resizer\">Image Resizer</a>."
                    },
                    {
                        "question": "Hvorfor velge WeryAI?",
                        "answer": "WeryAI bruker toppmoderne modeller for å analysere bildeegenskaper og sømløst outpainte omkringliggende områder med naturlige resultater i høy oppløsning."
                    },
                    {
                        "question": "Kan jeg bruke det gratis?",
                        "answer": "Ja! Nye brukere får gratis kreditter ved registrering — ingen kredittkort nødvendig. Tjen flere daglig via innsjekk, oppgaver og ved å invitere venner."
                    },
                    {
                        "question": "Hvor raskt er AI Bildeutvideren?",
                        "answer": "Det tar vanligvis noen sekunder. Ideelt for både raske redigeringer og batchbehandling."
                    },
                    {
                        "question": "Påvirkes oppløsningen eller kvaliteten?",
                        "answer": "Nei. Verktøyet bevarer oppløsning, skarphet og detaljer under utvidelsen — trygt for personlig og profesjonell bruk."
                    },
                    {
                        "question": "Forblir bildene mine private?",
                        "answer": "Ja. Vi beskytter dataene dine med bransjestandard sikkerhet og strenge personvernregler — bildene deles ikke med tredjeparter."
                    },
                    {
                        "question": "Hvilke bildeformater støttes?",
                        "answer": "JPG, PNG, WebP og andre vanlige formater. Maks filstørrelse er 10 MB — ingen konvertering nødvendig."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Hva er en AI Bildeutvider?",
                    "answer": "Et AI-verktøy som utvider bilder ved å fylle ut manglende innhold utenfor de opprinnelige grensene. Ideelt for markedsføring, e-handel og sosiale medier."
                },
                {
                    "question": "Hvorfor velge WeryAI?",
                    "answer": "Toppmoderne AI-modeller analyserer bildet og outpainter omkringliggende områder med naturlige, høyoppløselige resultater."
                },
                {
                    "question": "Kan jeg bruke det gratis?",
                    "answer": "Ja! Gratis kreditter ved registrering, ingen kort nødvendig. Tjen flere via innsjekk, oppgaver og invitasjoner."
                },
                {
                    "question": "Hvor raskt?",
                    "answer": "Vanligvis noen sekunder — perfekt for raske redigeringer og batchbehandling."
                },
                {
                    "question": "Bevares kvaliteten?",
                    "answer": "Ja. Oppløsning, skarphet og detaljer bevares under utvidelsen."
                },
                {
                    "question": "Er dataene mine trygge?",
                    "answer": "Ja. Bransjestandard sikkerhet og strenge personvernregler — ingen deling med tredjeparter."
                },
                {
                    "question": "Hvilke formater?",
                    "answer": "JPG, PNG, WebP og andre vanlige formater (maks. 10 MB)."
                }
            ],
            "feature_title1": "Gjenopprett manglende detaljer og bakgrunn",
            "feature_desc1": "Hvis bildet ditt ble beskåret, fyller AI intelligent ut de manglende detaljene for å gjøre rammen komplett. Outpainting gjenoppretter tapte elementer i gamle bilder og bringer verdifulle minner tilbake.",
            "feature_title2": "Utvid landskap og panoramaer",
            "feature_desc2": "Utvid kantene på landskaps- og panoramabilder for å skape brede komposisjoner med perfekt matchende bakgrunner.",
            "feature_title3": "Klar for e-handel og markedsføring",
            "feature_desc3": "Utvid området rundt produktbilder for å legge til naturlig kontekst. Skap bredere komposisjoner som viser flere produktdetaljer og øker konverteringer.",
            "feature_title4": "Optimaliser sideforhold for sosiale medier",
            "feature_desc4": "Utvid bilder til et hvilket som helst format for Instagram, X (tidligere Twitter), Facebook og mer. AI-en holder detaljene skarpe slik at sluttresultatet forblir iøynefallende.",
            "textRemoverHowToUseTitle": "Slik bruker du vår AI Bildeutvider",
            "textRemoverHowToUseDesc": "3 enkle trinn for å utvide bildet ditt utover kantene",
            "textRemoverHowToUseStep1Title": "Last opp et bilde",
            "textRemoverHowToUseStep1Desc": "Klikk eller dra og slipp bildet du vil utvide.",
            "textRemoverHowToUseStep2Title": "AI behandler automatisk",
            "textRemoverHowToUseStep2Desc": "Etter opplasting vil AI-en automatisk oppdage og utvide bildekantene.",
            "textRemoverHowToUseStep3Title": "Last ned det utvidede bildet",
            "textRemoverHowToUseStep3Desc": "Når det er klart, forhåndsvis og last ned det utvidede bildet ditt!",
            "howto": {
                "name": "Hvordan utvide et bilde med AI",
                "step1": {
                    "name": "Last opp bilde",
                    "text": "Last opp bildet du vil utvide til WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Velg område",
                    "text": "Velg området eller sideforholdet du vil utvide bildet til."
                },
                "step3": {
                    "name": "AI Outpainting",
                    "text": "Klikk på 'Opprett'. AI-en vil intelligent generere nye piksler og sømløst utvide bildet ditt."
                }
            }
        }
    },
    "nl": {
        "imgExtender": {
            "title": "Gratis AI Beelduitbreider - Outpaint Foto's | WeryAI",
            "description": "Breid afbeeldingen uit voorbij de originele randen met AI outpainting. Genereer naadloze content die aansluit bij de originele scène. Gratis credits bij registratie.",
            "keywords": "AI beelduitbreider, outpainting, afbeelding uitbreiden, beelduitbreiding, generatieve vulling, WeryAI",
            "og_title": "Gratis AI Beelduitbreider - Outpaint Foto's | WeryAI",
            "og_description": "Breid afbeeldingen uit voorbij de originele randen met AI outpainting. Genereer naadloze content die aansluit bij de originele scène.",
            "twitter_title": "Gratis AI Beelduitbreider - Outpaint Foto's | WeryAI",
            "twitter_description": "Breid afbeeldingen uit voorbij de originele randen met AI outpainting. Genereer naadloze content die aansluit bij de originele scène.",
            "featureList": [
                "AI beelduitbreider, gratis beelduitbreiding, outpainting, kwaliteit behouden"
            ],
            "page": {
                "title1": "Krachtige AI Beelduitbreider voor verbluffende resultaten",
                "title2": "Met enkele klikken breid je je foto uit voorbij de originele randen. Onze AI genereert nieuwe pixels die naadloos aansluiten bij je upload — maak van portretten groothoekfoto's terwijl het originele uiterlijk en de kwaliteit behouden blijven.",
                "feature_title": "Wat maakt de WeryAI Beelduitbreider bijzonder | WeryAI",
                "faq": [
                    {
                        "question": "Wat is een AI Beelduitbreider?",
                        "answer": "Een tool aangedreven door geavanceerde AI die een afbeelding uitbreidt door intelligent ontbrekende gebieden buiten de originele grenzen in te vullen. Het creëert een grotere versie van je foto — ideaal voor marketing, e-commerce en social media. Moet je het formaat wijzigen? Probeer onze <a href=\"/ai-image-resizer\">Image Resizer</a>."
                    },
                    {
                        "question": "Waarom WeryAI kiezen?",
                        "answer": "WeryAI gebruikt geavanceerde modellen om beeldkenmerken te analyseren en omliggende gebieden naadloos te outpainten met natuurlijke resultaten in hoge resolutie."
                    },
                    {
                        "question": "Kan ik het gratis gebruiken?",
                        "answer": "Ja! Nieuwe gebruikers krijgen gratis credits bij registratie — geen creditcard nodig. Verdien dagelijks meer via check-in, taken voltooien en vrienden uitnodigen."
                    },
                    {
                        "question": "Hoe snel is de AI Beelduitbreider?",
                        "answer": "Het duurt meestal slechts enkele seconden. Ideaal voor zowel snelle bewerkingen als batchverwerking."
                    },
                    {
                        "question": "Wordt de resolutie of kwaliteit aangetast?",
                        "answer": "Nee. De tool behoudt resolutie, scherpte en details tijdens het uitbreiden — veilig voor persoonlijk en professioneel gebruik."
                    },
                    {
                        "question": "Blijven mijn afbeeldingen privé?",
                        "answer": "Ja. We beschermen je gegevens met branchestandaard beveiliging en strikt privacybeleid — je afbeeldingen worden niet gedeeld met derden."
                    },
                    {
                        "question": "Welke beeldformaten worden ondersteund?",
                        "answer": "JPG, PNG, WebP en andere gangbare formaten. Maximale bestandsgrootte is 10 MB — geen conversie nodig."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Wat is een AI Beelduitbreider?",
                    "answer": "Een AI-tool die afbeeldingen uitbreidt door intelligent ontbrekende content buiten de originele grenzen in te vullen. Ideaal voor marketing, e-commerce en social media."
                },
                {
                    "question": "Waarom WeryAI?",
                    "answer": "Geavanceerde AI-modellen analyseren het beeld en outpainten omliggende gebieden met natuurlijke, hoge-resolutie resultaten."
                },
                {
                    "question": "Kan ik het gratis gebruiken?",
                    "answer": "Ja! Gratis credits bij registratie, geen kaart nodig. Verdien meer via check-in, taken en uitnodigingen."
                },
                {
                    "question": "Hoe snel?",
                    "answer": "Meestal enkele seconden — perfect voor snelle bewerkingen en batchverwerking."
                },
                {
                    "question": "Blijft de kwaliteit behouden?",
                    "answer": "Ja. Resolutie, scherpte en details worden behouden tijdens het uitbreiden."
                },
                {
                    "question": "Zijn mijn gegevens veilig?",
                    "answer": "Ja. Branchestandaard beveiliging en strikt privacybeleid — geen deling met derden."
                },
                {
                    "question": "Welke formaten?",
                    "answer": "JPG, PNG, WebP en andere gangbare formaten (max. 10 MB)."
                }
            ],
            "feature_title1": "Herstel ontbrekende details en achtergrond",
            "feature_desc1": "Als je foto is bijgesneden, vult de AI op intelligente wijze de ontbrekende details aan om het beeld compleet te maken. Outpainting herstelt verloren elementen in oude foto's en brengt waardevolle herinneringen terug.",
            "feature_title2": "Breid landschappen en panorama's uit",
            "feature_desc2": "Breid de randen van landschaps- en panoramafoto's uit om brede composities te creëren met perfect passende achtergronden.",
            "feature_title3": "Klaar voor e-commerce en marketing",
            "feature_desc3": "Breid de ruimte rond productafbeeldingen uit om natuurlijke context toe te voegen. Creëer bredere composities die meer productdetails tonen en conversies verhogen.",
            "feature_title4": "Optimaliseer beeldverhoudingen voor social media",
            "feature_desc4": "Breid afbeeldingen uit naar elke verhouding voor Instagram, X (voorheen Twitter), Facebook en meer. De AI houdt details scherp zodat het eindresultaat opvallend blijft.",
            "textRemoverHowToUseTitle": "Hoe gebruik je onze AI Beelduitbreider",
            "textRemoverHowToUseDesc": "3 eenvoudige stappen om je foto uit te breiden voorbij de randen",
            "textRemoverHowToUseStep1Title": "Upload een afbeelding",
            "textRemoverHowToUseStep1Desc": "Klik of sleep de afbeelding die je wilt uitbreiden.",
            "textRemoverHowToUseStep2Title": "AI verwerkt automatisch",
            "textRemoverHowToUseStep2Desc": "Na het uploaden detecteert en breidt de AI automatisch de beeldranden uit.",
            "textRemoverHowToUseStep3Title": "Download de uitgebreide afbeelding",
            "textRemoverHowToUseStep3Desc": "Wanneer het klaar is, bekijk en download je uitgebreide afbeelding!",
            "howto": {
                "name": "Hoe een afbeelding uit te breiden met AI",
                "step1": {
                    "name": "Upload foto",
                    "text": "Upload de foto die u wilt uitbreiden naar WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Selecteer gebied",
                    "text": "Selecteer het gebied of de beeldverhouding waarnaar u de afbeelding wilt uitbreiden."
                },
                "step3": {
                    "name": "AI Outpainting",
                    "text": "Klik op 'Maken'. De AI genereert op intelligente wijze nieuwe pixels en breidt uw afbeelding naadloos uit."
                }
            }
        }
    },
    "id": {
        "imgExtender": {
            "title": "AI Perluas Gambar Gratis - Outpaint Foto | WeryAI",
            "description": "Perluas gambar melampaui batas asli dengan AI outpainting. Hasilkan konten mulus yang sesuai dengan pemandangan asli. Kredit gratis saat mendaftar, tanpa kartu.",
            "keywords": "AI perluas gambar, outpainting, perluas foto, perluasan gambar, generative fill, WeryAI",
            "og_title": "AI Perluas Gambar Gratis - Outpaint Foto | WeryAI",
            "og_description": "Perluas gambar melampaui batas asli dengan AI outpainting. Hasilkan konten mulus yang sesuai dengan pemandangan asli.",
            "twitter_title": "AI Perluas Gambar Gratis - Outpaint Foto | WeryAI",
            "twitter_description": "Perluas gambar melampaui batas asli dengan AI outpainting. Hasilkan konten mulus yang sesuai dengan pemandangan asli.",
            "featureList": [
                "AI perluas gambar, perluasan gambar gratis, outpainting, pertahankan kualitas"
            ],
            "page": {
                "title1": "AI Perluas Gambar yang Canggih untuk Hasil Memukau",
                "title2": "Dengan beberapa klik, perluas foto Anda melampaui batas asli. AI menghasilkan piksel baru yang menyatu sempurna dengan unggahan Anda — ubah potret menjadi foto sudut lebar sambil mempertahankan tampilan dan kualitas asli.",
                "feature_title": "Apa yang membuat WeryAI Perluas Gambar istimewa | WeryAI",
                "faq": [
                    {
                        "question": "Apa itu AI Perluas Gambar?",
                        "answer": "Alat bertenaga AI canggih yang memperluas gambar dengan mengisi area yang hilang di luar batas asli secara cerdas. Membuat versi foto yang lebih besar — cocok untuk pemasaran, e-commerce, dan media sosial. Perlu mengubah ukuran? Coba <a href=\"/ai-image-resizer\">Image Resizer</a> kami."
                    },
                    {
                        "question": "Mengapa memilih WeryAI?",
                        "answer": "WeryAI menggunakan model mutakhir untuk menganalisis fitur gambar dan melakukan outpainting area sekitar dengan mulus, menghasilkan hasil alami beresolusi tinggi."
                    },
                    {
                        "question": "Bisakah digunakan gratis?",
                        "answer": "Ya! Pengguna baru mendapat kredit gratis saat mendaftar — tanpa kartu kredit. Dapatkan lebih banyak setiap hari melalui check-in, menyelesaikan tugas, dan mengundang teman."
                    },
                    {
                        "question": "Seberapa cepat AI Perluas Gambar?",
                        "answer": "Biasanya selesai dalam hitungan detik. Ideal untuk pengeditan cepat maupun pemrosesan batch."
                    },
                    {
                        "question": "Apakah resolusi atau kualitas terpengaruh?",
                        "answer": "Tidak. Alat ini mempertahankan resolusi, ketajaman, dan detail selama perluasan — aman untuk penggunaan pribadi dan profesional."
                    },
                    {
                        "question": "Apakah gambar saya tetap privat?",
                        "answer": "Ya. Kami melindungi data Anda dengan keamanan standar industri dan kebijakan privasi yang ketat — gambar Anda tidak dibagikan kepada pihak ketiga."
                    },
                    {
                        "question": "Format gambar apa saja yang didukung?",
                        "answer": "JPG, PNG, WebP, dan format umum lainnya. Ukuran file maksimal 10 MB — tanpa perlu konversi."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Apa itu AI Perluas Gambar?",
                    "answer": "Alat AI yang memperluas gambar dengan mengisi area yang hilang di luar batas asli secara cerdas. Cocok untuk pemasaran, e-commerce, dan media sosial."
                },
                {
                    "question": "Mengapa memilih WeryAI?",
                    "answer": "Model AI mutakhir menganalisis gambar dan melakukan outpainting area sekitar dengan hasil alami beresolusi tinggi."
                },
                {
                    "question": "Bisakah digunakan gratis?",
                    "answer": "Ya! Kredit gratis saat mendaftar, tanpa kartu. Dapatkan lebih banyak melalui check-in, tugas, dan undangan."
                },
                {
                    "question": "Seberapa cepat?",
                    "answer": "Biasanya hitungan detik — ideal untuk pengeditan cepat dan pemrosesan batch."
                },
                {
                    "question": "Apakah kualitas terjaga?",
                    "answer": "Ya. Resolusi, ketajaman, dan detail dipertahankan selama perluasan."
                },
                {
                    "question": "Apakah data saya aman?",
                    "answer": "Ya. Keamanan standar industri dan kebijakan privasi ketat — tidak dibagikan kepada pihak ketiga."
                },
                {
                    "question": "Format apa saja yang didukung?",
                    "answer": "JPG, PNG, WebP, dan format umum lainnya (maks. 10 MB)."
                }
            ],
            "feature_title1": "Pulihkan detail dan latar belakang yang hilang",
            "feature_desc1": "Jika foto Anda terpotong, AI dengan cerdas mengisi detail yang hilang untuk melengkapi bingkai. Outpainting memulihkan elemen yang hilang di foto lama dan mengembalikan kenangan berharga.",
            "feature_title2": "Perluas pemandangan dan panorama",
            "feature_desc2": "Perluas tepi foto pemandangan dan panorama untuk membuat komposisi lebar dengan latar belakang yang cocok sempurna.",
            "feature_title3": "Siap untuk e-commerce dan pemasaran",
            "feature_desc3": "Perluas area di sekitar gambar produk untuk menambahkan konteks alami. Buat komposisi yang lebih lebar untuk menampilkan lebih banyak detail produk dan meningkatkan konversi.",
            "feature_title4": "Optimalkan rasio aspek untuk media sosial",
            "feature_desc4": "Perluas gambar agar sesuai dengan rasio apa pun untuk Instagram, X (sebelumnya Twitter), Facebook, dan lainnya. AI menjaga detail tetap tajam sehingga hasil akhir tetap menarik perhatian.",
            "textRemoverHowToUseTitle": "Cara menggunakan AI Perluas Gambar kami",
            "textRemoverHowToUseDesc": "3 langkah mudah untuk memperluas foto Anda melampaui batasnya",
            "textRemoverHowToUseStep1Title": "Unggah gambar",
            "textRemoverHowToUseStep1Desc": "Klik atau seret dan lepas gambar yang ingin Anda perluas.",
            "textRemoverHowToUseStep2Title": "AI memproses otomatis",
            "textRemoverHowToUseStep2Desc": "Setelah diunggah, AI akan otomatis mendeteksi dan memperluas batas gambar.",
            "textRemoverHowToUseStep3Title": "Unduh gambar yang diperluas",
            "textRemoverHowToUseStep3Desc": "Saat sudah siap, pratinjau dan unduh gambar Anda yang telah diperluas!",
            "howto": {
                "name": "Cara Memperluas Gambar dengan AI",
                "step1": {
                    "name": "Unggah Foto",
                    "text": "Unggah foto yang ingin Anda perluas ke WeryAI AI Image Extender."
                },
                "step2": {
                    "name": "Pilih Area",
                    "text": "Pilih area atau rasio aspek yang ingin Anda perluas gambarnya."
                },
                "step3": {
                    "name": "Outpainting AI",
                    "text": "Klik 'Buat'. AI akan secara cerdas menghasilkan piksel baru dan memperluas gambar Anda dengan mulus."
                }
            }
        }
    },
    "tr": {
        "imgExtender": {
            "title": "Ücretsiz AI Görsel Genişletici - Fotoğraf Outpaint | WeryAI",
            "description": "AI outpainting ile görselleri orijinal sınırların ötesine genişletin. Orijinal sahneyle uyumlu kesintisiz içerik oluşturun. Kayıtta ücretsiz kredi, kart gerekmez.",
            "keywords": "AI görsel genişletici, outpainting, fotoğraf genişletme, görüntü genişletme, üretken doldurma, WeryAI",
            "og_title": "Ücretsiz AI Görsel Genişletici - Fotoğraf Outpaint | WeryAI",
            "og_description": "AI outpainting ile görselleri orijinal sınırların ötesine genişletin. Orijinal sahneyle uyumlu kesintisiz içerik oluşturun.",
            "twitter_title": "Ücretsiz AI Görsel Genişletici - Fotoğraf Outpaint | WeryAI",
            "twitter_description": "AI outpainting ile görselleri orijinal sınırların ötesine genişletin. Orijinal sahneyle uyumlu kesintisiz içerik oluşturun.",
            "featureList": [
                "AI görsel genişletici, ücretsiz görsel genişletme, outpainting, kaliteyi koruma"
            ],
            "page": {
                "title1": "Çarpıcı sonuçlar için güçlü AI Görsel Genişletici",
                "title2": "Birkaç tıkla fotoğrafınızı orijinal sınırların ötesine genişletin. Yapay zekamız yüklemenizle sorunsuzca birleşen yeni pikseller üretir — portreleri geniş açı fotoğraflara dönüştürürken orijinal görünümü ve kaliteyi korur.",
                "feature_title": "WeryAI Görsel Genişleticiyi özel kılan nedir | WeryAI",
                "faq": [
                    {
                        "question": "AI Görsel Genişletici nedir?",
                        "answer": "Gelişmiş yapay zeka ile çalışan bu araç, orijinal sınırların ötesindeki eksik alanları akıllıca doldurarak görseli genişletir. Fotoğrafınızın daha büyük bir versiyonunu oluşturur — pazarlama, e-ticaret ve sosyal medya için harika. Yeniden boyutlandırmanız mı gerekiyor? <a href=\"/ai-image-resizer\">Image Resizer</a> aracımızı deneyin."
                    },
                    {
                        "question": "Neden WeryAI?",
                        "answer": "WeryAI, görsel özelliklerini analiz etmek ve çevresindeki alanları doğal, yüksek çözünürlüklü sonuçlarla sorunsuzca outpaint etmek için en son teknolojiyi kullanır."
                    },
                    {
                        "question": "Ücretsiz kullanabilir miyim?",
                        "answer": "Evet! Yeni kullanıcılar kayıtta ücretsiz kredi alır — kredi kartı gerekmez. Check-in yaparak, görevleri tamamlayarak ve arkadaşlarınızı davet ederek her gün daha fazla kredi kazanın."
                    },
                    {
                        "question": "AI Görsel Genişletici ne kadar hızlı?",
                        "answer": "Genellikle birkaç saniye sürer. Hem hızlı düzenlemeler hem de toplu iş akışları için idealdir."
                    },
                    {
                        "question": "Çözünürlük veya kalite etkilenir mi?",
                        "answer": "Hayır. Araç, genişletme sırasında çözünürlüğü, netliği ve detayları korur — kişisel ve profesyonel kullanım için güvenlidir."
                    },
                    {
                        "question": "Görsellerim gizli kalır mı?",
                        "answer": "Evet. Verilerinizi endüstri standardı güvenlik ve sıkı gizlilik politikalarıyla koruyoruz — görselleriniz üçüncü taraflarla paylaşılmaz."
                    },
                    {
                        "question": "Hangi görsel formatları destekleniyor?",
                        "answer": "JPG, PNG, WebP ve diğer yaygın formatlar desteklenir. Maksimum dosya boyutu 10 MB — dönüştürme gerekmez."
                    }
                ]
            },
            "faq": [
                {
                    "question": "AI Görsel Genişletici nedir?",
                    "answer": "Orijinal sınırların ötesindeki eksik alanları akıllıca doldurarak görseli genişleten bir AI aracı. Pazarlama, e-ticaret ve sosyal medya için idealdir."
                },
                {
                    "question": "Neden WeryAI?",
                    "answer": "En son AI modelleri görseli analiz eder ve çevresindeki alanları doğal, yüksek çözünürlüklü sonuçlarla outpaint eder."
                },
                {
                    "question": "Ücretsiz kullanabilir miyim?",
                    "answer": "Evet! Kayıtta ücretsiz kredi, kart gerekmez. Check-in, görevler ve davetlerle daha fazla kazanın."
                },
                {
                    "question": "Ne kadar hızlı?",
                    "answer": "Genellikle birkaç saniye — hızlı düzenlemeler ve toplu işleme için mükemmel."
                },
                {
                    "question": "Kalite korunur mu?",
                    "answer": "Evet. Çözünürlük, netlik ve detaylar genişletme sırasında korunur."
                },
                {
                    "question": "Verilerim güvende mi?",
                    "answer": "Evet. Endüstri standardı güvenlik ve sıkı gizlilik politikaları — üçüncü taraflarla paylaşım yok."
                },
                {
                    "question": "Hangi formatlar destekleniyor?",
                    "answer": "JPG, PNG, WebP ve diğer yaygın formatlar (maks. 10 MB)."
                }
            ],
            "feature_title1": "Eksik detayları ve arka planı kurtarın",
            "feature_desc1": "Fotoğrafınız kırpılmışsa, AI eksik detayları akıllıca doldurarak çerçeveyi tamamlar. Outpainting, eski fotoğraflardaki kayıp öğeleri geri kazandırır ve değerli anıları canlandırır.",
            "feature_title2": "Manzaraları ve panoramaları genişletin",
            "feature_desc2": "Manzara ve panorama fotoğraflarının kenarlarını genişleterek mükemmel uyumlu arka planlarla geniş kompozisyonlar oluşturun.",
            "feature_title3": "E-ticaret ve pazarlamaya hazır",
            "feature_desc3": "Ürün görsellerinin çevresindeki alanı genişleterek doğal bağlam ekleyin. Daha fazla ürün detayı gösteren daha geniş kompozisyonlar oluşturun ve dönüşümleri artırın.",
            "feature_title4": "Sosyal medya için en boy oranlarını optimize edin",
            "feature_desc4": "Instagram, X (eski adıyla Twitter), Facebook ve daha fazlası için görselleri herhangi bir orana genişletin. AI detayları keskin tutar, böylece nihai sonuç göz alıcı kalır.",
            "textRemoverHowToUseTitle": "AI Görsel Genişleticimizi nasıl kullanırsınız",
            "textRemoverHowToUseDesc": "Fotoğrafınızı sınırlarının ötesine genişletmek için 3 basit adım",
            "textRemoverHowToUseStep1Title": "Bir görsel yükleyin",
            "textRemoverHowToUseStep1Desc": "Genişletmek istediğiniz görseli tıklayın veya sürükleyip bırakın.",
            "textRemoverHowToUseStep2Title": "AI otomatik olarak işler",
            "textRemoverHowToUseStep2Desc": "Yükleme sonrasında AI otomatik olarak görsel sınırlarını algılar ve genişletir.",
            "textRemoverHowToUseStep3Title": "Genişletilmiş görseli indirin",
            "textRemoverHowToUseStep3Desc": "Hazır olduğunda, genişletilmiş görselinizi önizleyin ve indirin!",
            "howto": {
                "name": "Yapay Zeka ile Bir Görüntü Nasıl Genişletilir",
                "step1": {
                    "name": "Fotoğraf Yükle",
                    "text": "Genişletmek istediğiniz fotoğrafı WeryAI AI Image Extender'a yükleyin."
                },
                "step2": {
                    "name": "Alan Seç",
                    "text": "Görüntüyü genişletmek istediğiniz alanı veya en boy oranını seçin."
                },
                "step3": {
                    "name": "Yapay Zeka Outpainting",
                    "text": "'Oluştur'u tıklayın. Yapay zeka akıllıca yeni pikseller üretecek ve görüntünüzü sorunsuz bir şekilde genişletecektir."
                }
            }
        }
    }
}
